// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v6.31.1
// source: bffbillsystem.proto

/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";

export const protobufPackage = "bff.v1";

export enum AreaType {
  AREA_TYPE_UNSPECIFIED = 0,
  AREA_TYPE_ROLLUP = 1,
  AREA_TYPE_RAAS = 2,
  UNRECOGNIZED = -1,
}

export function areaTypeFromJSON(object: any): AreaType {
  switch (object) {
    case 0:
    case "AREA_TYPE_UNSPECIFIED":
      return AreaType.AREA_TYPE_UNSPECIFIED;
    case 1:
    case "AREA_TYPE_ROLLUP":
      return AreaType.AREA_TYPE_ROLLUP;
    case 2:
    case "AREA_TYPE_RAAS":
      return AreaType.AREA_TYPE_RAAS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AreaType.UNRECOGNIZED;
  }
}

export function areaTypeToJSON(object: AreaType): string {
  switch (object) {
    case AreaType.AREA_TYPE_UNSPECIFIED:
      return "AREA_TYPE_UNSPECIFIED";
    case AreaType.AREA_TYPE_ROLLUP:
      return "AREA_TYPE_ROLLUP";
    case AreaType.AREA_TYPE_RAAS:
      return "AREA_TYPE_RAAS";
    case AreaType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface AgreementListRequest {
  status: string;
  serviceFeeStatus: string;
  withdrawFeeStatus: string;
  clientName: string;
}

export interface AgreementListReply {
  agreementInfo: SimpleAgreementInfo[];
}

export interface SimpleAgreementInfo {
  agreementId: number;
  agreementLink: string;
  /** Active/Pause/Terminated */
  agreementStatus: string;
  /** Awaiting/Paid/Overdue/PaidAfterOverdue */
  serviceFeeStatus: string;
  serviceFeeNextPayment: string;
  /** Awaiting/Paid/Overdue/PaidAfterOverdue */
  withdrawFeeStatus: string;
  withdrawFeeNextPayment: string;
  notes: string;
  clientName: string;
  paymentFrequency: string;
  otherFeeStatus: string;
  serviceFeeBalance: string;
}

export interface CreateAgreementRequest {
  clientName: string;
  clientNameInAgreement: string;
  contactEmails: string;
  agreementLink: string;
  /** Active/Pause/Terminated */
  agreementStatus: string;
  /** 1-testnet 2-mainnet 3-testnet&mainnet */
  agreementScope: number;
  /** Monthly/Quarterly/Yearly */
  paymentFrequency: string;
  amount: number;
  notes: string;
  withdrawFeePercentage: number;
}

export interface CreateAgreementReply {
}

export interface EditAgreementClientRequest {
  agreementId: number;
  clientName: string;
  clientNameInAgreement: string;
  contactEmails: string;
  bindingChains: string;
}

export interface EditAgreementClientReply {
}

export interface EditAgreementDetailsRequest {
  agreementId: number;
  agreementLink: string;
  /** Active/Pause/Terminated */
  agreementStatus: string;
  /** 1-testnet 2-mainnet 3-testnet&mainnet */
  agreementScope: number;
  /** Monthly/Quarterly/Yearly */
  paymentFrequency: string;
  amount: number;
  notes: string;
  withdrawFeePercentage: number;
}

export interface EditAgreementDetailsReply {
}

export interface AgreementInfoRequest {
  agreementId: number;
}

export interface AgreementInfoReply {
  agreementId: number;
  clientNameInAgreement: string;
  contactEmails: string;
  bindingChains: BindingChain[];
  agreementLink: string;
  /** Active/Pause/Terminated */
  agreementStatus: string;
  /** 1-testnet 2-mainnet 3-testnet&mainnet */
  agreementScope: number;
  /** Monthly/Quarterly/Yearly */
  paymentFrequency: string;
  amount: number;
  notes: string;
  /** Healthy/Overdue */
  billingStatus: string;
  clientName: string;
  withdrawFeePercentage: number;
}

export interface BindingChain {
  chainId: string;
  launchingDate: string;
  shutdownDate: string;
}

export interface DeleteAgreementRequest {
  agreementId: number;
}

export interface DeleteAgreementReply {
}

export interface PaymentTrackerRequest {
  agreementId: number;
}

export interface PaymentTrackerReply {
  serviceFee: ServiceFeeTracker | undefined;
  withdrawFee: WithdrawFeeTracker | undefined;
  otherFee: OtherFeeTracker | undefined;
}

export interface ServiceFeeTracker {
  /** Awaiting/Paid/Overdue/PaidAfterOverdue */
  status: string;
  paymentPeriodFrom: string;
  paymentPeriodTo: string;
  balance: string;
}

export interface WithdrawFeeTracker {
  /** Awaiting/Paid/Overdue/PaidAfterOverdue */
  status: string;
  paymentPeriodFrom: string;
  paymentPeriodTo: string;
  overdraft: string;
  /** ETH/BTC/USD */
  currency: string;
}

export interface OtherFeeTracker {
  subType: string;
  status: string;
  amount: string;
  currency: string;
}

export interface PaymentListRequest {
  agreementId: number;
  type: string;
}

export interface PaymentListReply {
  paymentInfo: SimplePaymentInfo[];
}

export interface SimplePaymentInfo {
  agreementId: number;
  /** service fee */
  type: string;
  subType: string;
  amount: string;
  /** USDT */
  currency: string;
  /** Awaiting/Paid/Overdue/PaidAfterOverdue */
  status: string;
  invoiceTime: string;
  paymentTime: string;
  paymentTxhash: string;
  paymentId: number;
}

export interface CreatePaymentRequest {
  agreementId: number;
  /** Additional fee */
  type: string;
  /** Backup full node */
  subType: string;
  amount: string;
  /** USDT */
  currency: string;
  /** Awaiting */
  status: string;
  /** 2024-11-01 00:00:00 */
  paymentPeriodFrom: string;
  /** 2024-11-30 00:00:00 */
  paymentPeriodTo: string;
  /** 2025-01-01 00:00:00 */
  nextPaymentDate: string;
  /** 2024-12-01 15:00:00 */
  invoiceTime: string;
  paymentTime: string;
  paymentTxhash: string;
}

export interface CreatePaymentReply {
}

export interface EditPaymentRequest {
  paymentId: number;
  agreementId: number;
  /** Additional fee */
  type: string;
  /** Backup full node */
  subType: string;
  amount: string;
  /** USDT */
  currency: string;
  /** Awaiting */
  status: string;
  /** 2024-11-01 */
  paymentPeriodFrom: string;
  /** 2024-11-30 */
  paymentPeriodTo: string;
  /** 2025-01-01 00:00:00 */
  nextPaymentDate: string;
  /** 2024-12-01 15:00:00 */
  invoiceTime: string;
  paymentTime: string;
  paymentTxhash: string;
}

export interface EditPaymentReply {
}

export interface PaymentInfoRequest {
  paymentId: number;
}

export interface PaymentInfoReply {
  agreementId: number;
  paymentId: number;
  /** Additional fee */
  type: string;
  /** Backup full node */
  subType: string;
  amount: string;
  /** USDT */
  currency: string;
  /** Paid */
  status: string;
  /** 2024-11-01 */
  paymentPeriodFrom: string;
  /** 2024-11-30 */
  paymentPeriodTo: string;
  /** 2025-01-01 00:00:00 */
  nextPaymentDate: string;
  /** 2024-12-01 15:00:00 */
  invoiceTime: string;
  /** 2024-12-02 15:00:00 */
  paymentTime: string;
  /** 0xb8aec51a3d564829cc2513dd767b93eb76aac4c293c96b921c177cf1fe033e2d */
  paymentTxhash: string;
}

export interface DeletePaymentRequest {
  paymentId: number;
}

export interface DeletePaymentReply {
}

export interface WithdrawMonthlyBillRequest {
  opstackId: string;
  billMonth: string;
}

export interface WithdrawMonthlyBillReply {
  withdrawBills: WithdrawBill[];
}

export interface WithdrawBill {
  billMonth: string;
  /** totle fee received this month */
  totalFee: string;
  totalBaseFee: string;
  totalL1Fee: string;
  totalSequencerFee: string;
  /** fee charged by altlayer */
  altlayerFee: string;
  /** fee charged by op */
  opFee: string;
  /** Gas fee deducted when initiating a txn */
  gasFee: string;
  /** total_fee - gas_fee - altlayer_fee - op_fee */
  earnings: string;
}

export interface AgreementCostListRequest {
  agreementId: number;
}

export interface AgreementCostListReply {
  costInfo: AgreementCostInfo[];
}

export interface AgreementCostInfo {
  agreementId: number;
  costId: number;
  amount: number;
  currency: string;
  notes: string;
  month: string;
}

export interface CreateAgreementCostRequest {
  agreementId: number;
  amount: number;
  currency: string;
  notes: string;
  month: string;
}

export interface CreateAgreementCostReply {
}

export interface EditAgreementCostRequest {
  agreementId: number;
  costId: number;
  amount: number;
  currency: string;
  notes: string;
  month: string;
}

export interface EditAgreementCostReply {
}

export interface AgreementCostInfoRequest {
  costId: number;
}

export interface AgreementCostInfoReply {
  agreementId: number;
  costId: number;
  amount: number;
  currency: string;
  notes: string;
  month: string;
}

export interface DeleteAgreementCostRequest {
  costId: number;
}

export interface DeleteAgreementCostReply {
}

export interface CostSummaryRequest {
  period: string;
  startDate: string;
  endDate: string;
  includeNode: boolean;
  namespace: string;
  kind: string;
  type: string;
  labels: string;
}

export interface CostSummaryReply {
  period: string;
  items: CostSummaryItem[];
}

export interface CostSummaryItem {
  periodStart: string;
  periodEnd: string;
  totalCost: number;
  details: CostSummaryDetails | undefined;
}

export interface CostSummaryDetails {
  compute: number;
  storage: number;
  network: number;
}

export interface CostSummaryV2Request {
  period: string;
  startDate: string;
  endDate: string;
  area: string;
  namespace: string;
  kind: string;
  type: string;
}

export interface CostSummaryV2Reply {
  period: string;
  items: CostSummaryItemV2[];
}

export interface CostSummaryItemV2 {
  periodStart: string;
  periodEnd: string;
  totalCost: number;
  details: CostSummaryDetailV2 | undefined;
}

export interface CostSummaryDetailV2 {
  compute: number;
  storage: number;
  network: number;
}

export interface ResourceNamespaceListRequest {
  /** rollup/raas */
  type: string;
}

export interface ResourceNamespaceListReply {
  namespace: string[];
}

export interface BusinessCostSummaryRequest {
  namespace: string;
  startTime: string;
  endTime: string;
  business: string;
  kind: string;
  type: string;
  subResource: string;
  interval: string;
  area: AreaType;
}

export interface BusinessCostSummaryReply {
  items: BusinessCostRecord[];
}

export interface BusinessCostRecord {
  id: number;
  billingUnitId: number;
  valueCounter: number;
  startTime: string;
  endTime: string;
  interval: string;
  costCounter: number;
  name: string;
  business: string;
  kind: string;
  type: string;
  subResource: string;
  k8sAppName: string;
}

/** PeriodicCostRecordsRequest represents the request parameters for getting periodic cost records */
export interface PeriodicCostRecordsRequest {
  /** Required parameters */
  startTime: string;
  /** End time in format "YYYY-MM-DD" */
  endTime: string;
  /** Optional parameters */
  namespace: string;
  /** Filter by resource kind(s), default excludes Node. Use kind=Pod,Service,... */
  kind: string;
  /** Filter by billing type(s). Use type=CPU,Memory,... */
  type: string;
  /** Filter by subresource(s). Use subresource=requests,limits,... */
  subresource: string;
  /** Filter by billing unit ID */
  billingUnitId: number;
  /** Filter by resource name */
  resourceName: string;
  /** Filter by resource name regex */
  nameRegex: string;
  /** JSON format label filter conditions, e.g.: {"app":"nginx"} */
  labels: string;
  /** Filter by interval type (hourly, daily, weekly, monthly) */
  interval: string;
  /** Page number, starting from 1 */
  page: number;
  /** Records per page, maximum 100 */
  pageSize: number;
}

/** PeriodicCostRecordsReply represents the response for periodic cost records */
export interface PeriodicCostRecordsReply {
  items: PeriodicCostRecord[];
  meta: Meta | undefined;
}

/** PeriodicCostRecord represents a single cost record entry */
export interface PeriodicCostRecord {
  id: number;
  billingUnitId: number;
  billingUnit: BillingUnit | undefined;
  startTime: string;
  endTime: string;
  interval: string;
  costCounter: number;
  valueCounter: number;
}

/** BillingUnit represents the billing unit information */
export interface BillingUnit {
  id: number;
  resourceId: string;
  description?: string | undefined;
  kind: string;
  name: string;
  namespace: string;
  type: string;
  subresourceName: string;
  subresourceValue?: string | undefined;
  attributes: { [key: string]: number };
  pricePerUnit: number;
  creationTimestamp: string;
  deletionTimestamp?: string | undefined;
}

export interface BillingUnit_AttributesEntry {
  key: string;
  value: number;
}

/** Meta represents pagination metadata */
export interface Meta {
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface ResourceNameListRequest {
  /** Start time in format "YYYY-MM-DD" */
  startTime: string;
  /** End time in format "YYYY-MM-DD" */
  endTime: string;
  /** Filter by namespace(s). Use namespace=ns1,ns2,... */
  namespace: string;
  /** Filter by resource kind(s), default excludes Node. Use kind=Pod,Service,... */
  kind: string;
  /** Filter by billing type(s). Use type=CPU,Memory,... */
  type: string;
  subresource: string;
  /** Filter by resource name regex */
  nameRegex: string;
}

export interface ResourceNameListReply {
  list: string[];
}

function createBaseAgreementListRequest(): AgreementListRequest {
  return { status: "", serviceFeeStatus: "", withdrawFeeStatus: "", clientName: "" };
}

export const AgreementListRequest = {
  encode(message: AgreementListRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.status !== "") {
      writer.uint32(10).string(message.status);
    }
    if (message.serviceFeeStatus !== "") {
      writer.uint32(18).string(message.serviceFeeStatus);
    }
    if (message.withdrawFeeStatus !== "") {
      writer.uint32(26).string(message.withdrawFeeStatus);
    }
    if (message.clientName !== "") {
      writer.uint32(34).string(message.clientName);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AgreementListRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAgreementListRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.status = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.serviceFeeStatus = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.withdrawFeeStatus = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.clientName = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AgreementListRequest {
    return {
      status: isSet(object.status) ? globalThis.String(object.status) : "",
      serviceFeeStatus: isSet(object.serviceFeeStatus) ? globalThis.String(object.serviceFeeStatus) : "",
      withdrawFeeStatus: isSet(object.withdrawFeeStatus) ? globalThis.String(object.withdrawFeeStatus) : "",
      clientName: isSet(object.clientName) ? globalThis.String(object.clientName) : "",
    };
  },

  toJSON(message: AgreementListRequest): unknown {
    const obj: any = {};
    if (message.status !== "") {
      obj.status = message.status;
    }
    if (message.serviceFeeStatus !== "") {
      obj.serviceFeeStatus = message.serviceFeeStatus;
    }
    if (message.withdrawFeeStatus !== "") {
      obj.withdrawFeeStatus = message.withdrawFeeStatus;
    }
    if (message.clientName !== "") {
      obj.clientName = message.clientName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AgreementListRequest>, I>>(base?: I): AgreementListRequest {
    return AgreementListRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AgreementListRequest>, I>>(object: I): AgreementListRequest {
    const message = createBaseAgreementListRequest();
    message.status = object.status ?? "";
    message.serviceFeeStatus = object.serviceFeeStatus ?? "";
    message.withdrawFeeStatus = object.withdrawFeeStatus ?? "";
    message.clientName = object.clientName ?? "";
    return message;
  },
};

function createBaseAgreementListReply(): AgreementListReply {
  return { agreementInfo: [] };
}

export const AgreementListReply = {
  encode(message: AgreementListReply, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.agreementInfo) {
      SimpleAgreementInfo.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AgreementListReply {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAgreementListReply();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.agreementInfo.push(SimpleAgreementInfo.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AgreementListReply {
    return {
      agreementInfo: globalThis.Array.isArray(object?.agreementInfo)
        ? object.agreementInfo.map((e: any) => SimpleAgreementInfo.fromJSON(e))
        : [],
    };
  },

  toJSON(message: AgreementListReply): unknown {
    const obj: any = {};
    if (message.agreementInfo?.length) {
      obj.agreementInfo = message.agreementInfo.map((e) => SimpleAgreementInfo.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AgreementListReply>, I>>(base?: I): AgreementListReply {
    return AgreementListReply.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AgreementListReply>, I>>(object: I): AgreementListReply {
    const message = createBaseAgreementListReply();
    message.agreementInfo = object.agreementInfo?.map((e) => SimpleAgreementInfo.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSimpleAgreementInfo(): SimpleAgreementInfo {
  return {
    agreementId: 0,
    agreementLink: "",
    agreementStatus: "",
    serviceFeeStatus: "",
    serviceFeeNextPayment: "",
    withdrawFeeStatus: "",
    withdrawFeeNextPayment: "",
    notes: "",
    clientName: "",
    paymentFrequency: "",
    otherFeeStatus: "",
    serviceFeeBalance: "",
  };
}

export const SimpleAgreementInfo = {
  encode(message: SimpleAgreementInfo, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.agreementId !== 0) {
      writer.uint32(8).int32(message.agreementId);
    }
    if (message.agreementLink !== "") {
      writer.uint32(18).string(message.agreementLink);
    }
    if (message.agreementStatus !== "") {
      writer.uint32(26).string(message.agreementStatus);
    }
    if (message.serviceFeeStatus !== "") {
      writer.uint32(34).string(message.serviceFeeStatus);
    }
    if (message.serviceFeeNextPayment !== "") {
      writer.uint32(42).string(message.serviceFeeNextPayment);
    }
    if (message.withdrawFeeStatus !== "") {
      writer.uint32(50).string(message.withdrawFeeStatus);
    }
    if (message.withdrawFeeNextPayment !== "") {
      writer.uint32(58).string(message.withdrawFeeNextPayment);
    }
    if (message.notes !== "") {
      writer.uint32(66).string(message.notes);
    }
    if (message.clientName !== "") {
      writer.uint32(74).string(message.clientName);
    }
    if (message.paymentFrequency !== "") {
      writer.uint32(82).string(message.paymentFrequency);
    }
    if (message.otherFeeStatus !== "") {
      writer.uint32(90).string(message.otherFeeStatus);
    }
    if (message.serviceFeeBalance !== "") {
      writer.uint32(98).string(message.serviceFeeBalance);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SimpleAgreementInfo {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSimpleAgreementInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.agreementId = reader.int32();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.agreementLink = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.agreementStatus = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.serviceFeeStatus = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.serviceFeeNextPayment = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.withdrawFeeStatus = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.withdrawFeeNextPayment = reader.string();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.notes = reader.string();
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.clientName = reader.string();
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.paymentFrequency = reader.string();
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.otherFeeStatus = reader.string();
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.serviceFeeBalance = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SimpleAgreementInfo {
    return {
      agreementId: isSet(object.agreementId) ? globalThis.Number(object.agreementId) : 0,
      agreementLink: isSet(object.agreementLink) ? globalThis.String(object.agreementLink) : "",
      agreementStatus: isSet(object.agreementStatus) ? globalThis.String(object.agreementStatus) : "",
      serviceFeeStatus: isSet(object.serviceFeeStatus) ? globalThis.String(object.serviceFeeStatus) : "",
      serviceFeeNextPayment: isSet(object.serviceFeeNextPayment) ? globalThis.String(object.serviceFeeNextPayment) : "",
      withdrawFeeStatus: isSet(object.withdrawFeeStatus) ? globalThis.String(object.withdrawFeeStatus) : "",
      withdrawFeeNextPayment: isSet(object.withdrawFeeNextPayment)
        ? globalThis.String(object.withdrawFeeNextPayment)
        : "",
      notes: isSet(object.notes) ? globalThis.String(object.notes) : "",
      clientName: isSet(object.clientName) ? globalThis.String(object.clientName) : "",
      paymentFrequency: isSet(object.paymentFrequency) ? globalThis.String(object.paymentFrequency) : "",
      otherFeeStatus: isSet(object.otherFeeStatus) ? globalThis.String(object.otherFeeStatus) : "",
      serviceFeeBalance: isSet(object.serviceFeeBalance) ? globalThis.String(object.serviceFeeBalance) : "",
    };
  },

  toJSON(message: SimpleAgreementInfo): unknown {
    const obj: any = {};
    if (message.agreementId !== 0) {
      obj.agreementId = Math.round(message.agreementId);
    }
    if (message.agreementLink !== "") {
      obj.agreementLink = message.agreementLink;
    }
    if (message.agreementStatus !== "") {
      obj.agreementStatus = message.agreementStatus;
    }
    if (message.serviceFeeStatus !== "") {
      obj.serviceFeeStatus = message.serviceFeeStatus;
    }
    if (message.serviceFeeNextPayment !== "") {
      obj.serviceFeeNextPayment = message.serviceFeeNextPayment;
    }
    if (message.withdrawFeeStatus !== "") {
      obj.withdrawFeeStatus = message.withdrawFeeStatus;
    }
    if (message.withdrawFeeNextPayment !== "") {
      obj.withdrawFeeNextPayment = message.withdrawFeeNextPayment;
    }
    if (message.notes !== "") {
      obj.notes = message.notes;
    }
    if (message.clientName !== "") {
      obj.clientName = message.clientName;
    }
    if (message.paymentFrequency !== "") {
      obj.paymentFrequency = message.paymentFrequency;
    }
    if (message.otherFeeStatus !== "") {
      obj.otherFeeStatus = message.otherFeeStatus;
    }
    if (message.serviceFeeBalance !== "") {
      obj.serviceFeeBalance = message.serviceFeeBalance;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SimpleAgreementInfo>, I>>(base?: I): SimpleAgreementInfo {
    return SimpleAgreementInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SimpleAgreementInfo>, I>>(object: I): SimpleAgreementInfo {
    const message = createBaseSimpleAgreementInfo();
    message.agreementId = object.agreementId ?? 0;
    message.agreementLink = object.agreementLink ?? "";
    message.agreementStatus = object.agreementStatus ?? "";
    message.serviceFeeStatus = object.serviceFeeStatus ?? "";
    message.serviceFeeNextPayment = object.serviceFeeNextPayment ?? "";
    message.withdrawFeeStatus = object.withdrawFeeStatus ?? "";
    message.withdrawFeeNextPayment = object.withdrawFeeNextPayment ?? "";
    message.notes = object.notes ?? "";
    message.clientName = object.clientName ?? "";
    message.paymentFrequency = object.paymentFrequency ?? "";
    message.otherFeeStatus = object.otherFeeStatus ?? "";
    message.serviceFeeBalance = object.serviceFeeBalance ?? "";
    return message;
  },
};

function createBaseCreateAgreementRequest(): CreateAgreementRequest {
  return {
    clientName: "",
    clientNameInAgreement: "",
    contactEmails: "",
    agreementLink: "",
    agreementStatus: "",
    agreementScope: 0,
    paymentFrequency: "",
    amount: 0,
    notes: "",
    withdrawFeePercentage: 0,
  };
}

export const CreateAgreementRequest = {
  encode(message: CreateAgreementRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.clientName !== "") {
      writer.uint32(10).string(message.clientName);
    }
    if (message.clientNameInAgreement !== "") {
      writer.uint32(18).string(message.clientNameInAgreement);
    }
    if (message.contactEmails !== "") {
      writer.uint32(26).string(message.contactEmails);
    }
    if (message.agreementLink !== "") {
      writer.uint32(34).string(message.agreementLink);
    }
    if (message.agreementStatus !== "") {
      writer.uint32(42).string(message.agreementStatus);
    }
    if (message.agreementScope !== 0) {
      writer.uint32(48).int32(message.agreementScope);
    }
    if (message.paymentFrequency !== "") {
      writer.uint32(58).string(message.paymentFrequency);
    }
    if (message.amount !== 0) {
      writer.uint32(64).int32(message.amount);
    }
    if (message.notes !== "") {
      writer.uint32(74).string(message.notes);
    }
    if (message.withdrawFeePercentage !== 0) {
      writer.uint32(85).float(message.withdrawFeePercentage);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CreateAgreementRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateAgreementRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.clientName = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.clientNameInAgreement = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.contactEmails = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.agreementLink = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.agreementStatus = reader.string();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.agreementScope = reader.int32();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.paymentFrequency = reader.string();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.amount = reader.int32();
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.notes = reader.string();
          continue;
        case 10:
          if (tag !== 85) {
            break;
          }

          message.withdrawFeePercentage = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateAgreementRequest {
    return {
      clientName: isSet(object.clientName) ? globalThis.String(object.clientName) : "",
      clientNameInAgreement: isSet(object.clientNameInAgreement) ? globalThis.String(object.clientNameInAgreement) : "",
      contactEmails: isSet(object.contactEmails) ? globalThis.String(object.contactEmails) : "",
      agreementLink: isSet(object.agreementLink) ? globalThis.String(object.agreementLink) : "",
      agreementStatus: isSet(object.agreementStatus) ? globalThis.String(object.agreementStatus) : "",
      agreementScope: isSet(object.agreementScope) ? globalThis.Number(object.agreementScope) : 0,
      paymentFrequency: isSet(object.paymentFrequency) ? globalThis.String(object.paymentFrequency) : "",
      amount: isSet(object.amount) ? globalThis.Number(object.amount) : 0,
      notes: isSet(object.notes) ? globalThis.String(object.notes) : "",
      withdrawFeePercentage: isSet(object.withdrawFeePercentage) ? globalThis.Number(object.withdrawFeePercentage) : 0,
    };
  },

  toJSON(message: CreateAgreementRequest): unknown {
    const obj: any = {};
    if (message.clientName !== "") {
      obj.clientName = message.clientName;
    }
    if (message.clientNameInAgreement !== "") {
      obj.clientNameInAgreement = message.clientNameInAgreement;
    }
    if (message.contactEmails !== "") {
      obj.contactEmails = message.contactEmails;
    }
    if (message.agreementLink !== "") {
      obj.agreementLink = message.agreementLink;
    }
    if (message.agreementStatus !== "") {
      obj.agreementStatus = message.agreementStatus;
    }
    if (message.agreementScope !== 0) {
      obj.agreementScope = Math.round(message.agreementScope);
    }
    if (message.paymentFrequency !== "") {
      obj.paymentFrequency = message.paymentFrequency;
    }
    if (message.amount !== 0) {
      obj.amount = Math.round(message.amount);
    }
    if (message.notes !== "") {
      obj.notes = message.notes;
    }
    if (message.withdrawFeePercentage !== 0) {
      obj.withdrawFeePercentage = message.withdrawFeePercentage;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateAgreementRequest>, I>>(base?: I): CreateAgreementRequest {
    return CreateAgreementRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateAgreementRequest>, I>>(object: I): CreateAgreementRequest {
    const message = createBaseCreateAgreementRequest();
    message.clientName = object.clientName ?? "";
    message.clientNameInAgreement = object.clientNameInAgreement ?? "";
    message.contactEmails = object.contactEmails ?? "";
    message.agreementLink = object.agreementLink ?? "";
    message.agreementStatus = object.agreementStatus ?? "";
    message.agreementScope = object.agreementScope ?? 0;
    message.paymentFrequency = object.paymentFrequency ?? "";
    message.amount = object.amount ?? 0;
    message.notes = object.notes ?? "";
    message.withdrawFeePercentage = object.withdrawFeePercentage ?? 0;
    return message;
  },
};

function createBaseCreateAgreementReply(): CreateAgreementReply {
  return {};
}

export const CreateAgreementReply = {
  encode(_: CreateAgreementReply, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CreateAgreementReply {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateAgreementReply();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): CreateAgreementReply {
    return {};
  },

  toJSON(_: CreateAgreementReply): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateAgreementReply>, I>>(base?: I): CreateAgreementReply {
    return CreateAgreementReply.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateAgreementReply>, I>>(_: I): CreateAgreementReply {
    const message = createBaseCreateAgreementReply();
    return message;
  },
};

function createBaseEditAgreementClientRequest(): EditAgreementClientRequest {
  return { agreementId: 0, clientName: "", clientNameInAgreement: "", contactEmails: "", bindingChains: "" };
}

export const EditAgreementClientRequest = {
  encode(message: EditAgreementClientRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.agreementId !== 0) {
      writer.uint32(8).int32(message.agreementId);
    }
    if (message.clientName !== "") {
      writer.uint32(18).string(message.clientName);
    }
    if (message.clientNameInAgreement !== "") {
      writer.uint32(26).string(message.clientNameInAgreement);
    }
    if (message.contactEmails !== "") {
      writer.uint32(34).string(message.contactEmails);
    }
    if (message.bindingChains !== "") {
      writer.uint32(42).string(message.bindingChains);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): EditAgreementClientRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEditAgreementClientRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.agreementId = reader.int32();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.clientName = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.clientNameInAgreement = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.contactEmails = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.bindingChains = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EditAgreementClientRequest {
    return {
      agreementId: isSet(object.agreementId) ? globalThis.Number(object.agreementId) : 0,
      clientName: isSet(object.clientName) ? globalThis.String(object.clientName) : "",
      clientNameInAgreement: isSet(object.clientNameInAgreement) ? globalThis.String(object.clientNameInAgreement) : "",
      contactEmails: isSet(object.contactEmails) ? globalThis.String(object.contactEmails) : "",
      bindingChains: isSet(object.bindingChains) ? globalThis.String(object.bindingChains) : "",
    };
  },

  toJSON(message: EditAgreementClientRequest): unknown {
    const obj: any = {};
    if (message.agreementId !== 0) {
      obj.agreementId = Math.round(message.agreementId);
    }
    if (message.clientName !== "") {
      obj.clientName = message.clientName;
    }
    if (message.clientNameInAgreement !== "") {
      obj.clientNameInAgreement = message.clientNameInAgreement;
    }
    if (message.contactEmails !== "") {
      obj.contactEmails = message.contactEmails;
    }
    if (message.bindingChains !== "") {
      obj.bindingChains = message.bindingChains;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EditAgreementClientRequest>, I>>(base?: I): EditAgreementClientRequest {
    return EditAgreementClientRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EditAgreementClientRequest>, I>>(object: I): EditAgreementClientRequest {
    const message = createBaseEditAgreementClientRequest();
    message.agreementId = object.agreementId ?? 0;
    message.clientName = object.clientName ?? "";
    message.clientNameInAgreement = object.clientNameInAgreement ?? "";
    message.contactEmails = object.contactEmails ?? "";
    message.bindingChains = object.bindingChains ?? "";
    return message;
  },
};

function createBaseEditAgreementClientReply(): EditAgreementClientReply {
  return {};
}

export const EditAgreementClientReply = {
  encode(_: EditAgreementClientReply, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): EditAgreementClientReply {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEditAgreementClientReply();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): EditAgreementClientReply {
    return {};
  },

  toJSON(_: EditAgreementClientReply): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<EditAgreementClientReply>, I>>(base?: I): EditAgreementClientReply {
    return EditAgreementClientReply.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EditAgreementClientReply>, I>>(_: I): EditAgreementClientReply {
    const message = createBaseEditAgreementClientReply();
    return message;
  },
};

function createBaseEditAgreementDetailsRequest(): EditAgreementDetailsRequest {
  return {
    agreementId: 0,
    agreementLink: "",
    agreementStatus: "",
    agreementScope: 0,
    paymentFrequency: "",
    amount: 0,
    notes: "",
    withdrawFeePercentage: 0,
  };
}

export const EditAgreementDetailsRequest = {
  encode(message: EditAgreementDetailsRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.agreementId !== 0) {
      writer.uint32(8).int32(message.agreementId);
    }
    if (message.agreementLink !== "") {
      writer.uint32(18).string(message.agreementLink);
    }
    if (message.agreementStatus !== "") {
      writer.uint32(26).string(message.agreementStatus);
    }
    if (message.agreementScope !== 0) {
      writer.uint32(32).int32(message.agreementScope);
    }
    if (message.paymentFrequency !== "") {
      writer.uint32(42).string(message.paymentFrequency);
    }
    if (message.amount !== 0) {
      writer.uint32(48).int32(message.amount);
    }
    if (message.notes !== "") {
      writer.uint32(58).string(message.notes);
    }
    if (message.withdrawFeePercentage !== 0) {
      writer.uint32(69).float(message.withdrawFeePercentage);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): EditAgreementDetailsRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEditAgreementDetailsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.agreementId = reader.int32();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.agreementLink = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.agreementStatus = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.agreementScope = reader.int32();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.paymentFrequency = reader.string();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.amount = reader.int32();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.notes = reader.string();
          continue;
        case 8:
          if (tag !== 69) {
            break;
          }

          message.withdrawFeePercentage = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EditAgreementDetailsRequest {
    return {
      agreementId: isSet(object.agreementId) ? globalThis.Number(object.agreementId) : 0,
      agreementLink: isSet(object.agreementLink) ? globalThis.String(object.agreementLink) : "",
      agreementStatus: isSet(object.agreementStatus) ? globalThis.String(object.agreementStatus) : "",
      agreementScope: isSet(object.agreementScope) ? globalThis.Number(object.agreementScope) : 0,
      paymentFrequency: isSet(object.paymentFrequency) ? globalThis.String(object.paymentFrequency) : "",
      amount: isSet(object.amount) ? globalThis.Number(object.amount) : 0,
      notes: isSet(object.notes) ? globalThis.String(object.notes) : "",
      withdrawFeePercentage: isSet(object.withdrawFeePercentage) ? globalThis.Number(object.withdrawFeePercentage) : 0,
    };
  },

  toJSON(message: EditAgreementDetailsRequest): unknown {
    const obj: any = {};
    if (message.agreementId !== 0) {
      obj.agreementId = Math.round(message.agreementId);
    }
    if (message.agreementLink !== "") {
      obj.agreementLink = message.agreementLink;
    }
    if (message.agreementStatus !== "") {
      obj.agreementStatus = message.agreementStatus;
    }
    if (message.agreementScope !== 0) {
      obj.agreementScope = Math.round(message.agreementScope);
    }
    if (message.paymentFrequency !== "") {
      obj.paymentFrequency = message.paymentFrequency;
    }
    if (message.amount !== 0) {
      obj.amount = Math.round(message.amount);
    }
    if (message.notes !== "") {
      obj.notes = message.notes;
    }
    if (message.withdrawFeePercentage !== 0) {
      obj.withdrawFeePercentage = message.withdrawFeePercentage;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EditAgreementDetailsRequest>, I>>(base?: I): EditAgreementDetailsRequest {
    return EditAgreementDetailsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EditAgreementDetailsRequest>, I>>(object: I): EditAgreementDetailsRequest {
    const message = createBaseEditAgreementDetailsRequest();
    message.agreementId = object.agreementId ?? 0;
    message.agreementLink = object.agreementLink ?? "";
    message.agreementStatus = object.agreementStatus ?? "";
    message.agreementScope = object.agreementScope ?? 0;
    message.paymentFrequency = object.paymentFrequency ?? "";
    message.amount = object.amount ?? 0;
    message.notes = object.notes ?? "";
    message.withdrawFeePercentage = object.withdrawFeePercentage ?? 0;
    return message;
  },
};

function createBaseEditAgreementDetailsReply(): EditAgreementDetailsReply {
  return {};
}

export const EditAgreementDetailsReply = {
  encode(_: EditAgreementDetailsReply, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): EditAgreementDetailsReply {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEditAgreementDetailsReply();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): EditAgreementDetailsReply {
    return {};
  },

  toJSON(_: EditAgreementDetailsReply): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<EditAgreementDetailsReply>, I>>(base?: I): EditAgreementDetailsReply {
    return EditAgreementDetailsReply.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EditAgreementDetailsReply>, I>>(_: I): EditAgreementDetailsReply {
    const message = createBaseEditAgreementDetailsReply();
    return message;
  },
};

function createBaseAgreementInfoRequest(): AgreementInfoRequest {
  return { agreementId: 0 };
}

export const AgreementInfoRequest = {
  encode(message: AgreementInfoRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.agreementId !== 0) {
      writer.uint32(8).int32(message.agreementId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AgreementInfoRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAgreementInfoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.agreementId = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AgreementInfoRequest {
    return { agreementId: isSet(object.agreementId) ? globalThis.Number(object.agreementId) : 0 };
  },

  toJSON(message: AgreementInfoRequest): unknown {
    const obj: any = {};
    if (message.agreementId !== 0) {
      obj.agreementId = Math.round(message.agreementId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AgreementInfoRequest>, I>>(base?: I): AgreementInfoRequest {
    return AgreementInfoRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AgreementInfoRequest>, I>>(object: I): AgreementInfoRequest {
    const message = createBaseAgreementInfoRequest();
    message.agreementId = object.agreementId ?? 0;
    return message;
  },
};

function createBaseAgreementInfoReply(): AgreementInfoReply {
  return {
    agreementId: 0,
    clientNameInAgreement: "",
    contactEmails: "",
    bindingChains: [],
    agreementLink: "",
    agreementStatus: "",
    agreementScope: 0,
    paymentFrequency: "",
    amount: 0,
    notes: "",
    billingStatus: "",
    clientName: "",
    withdrawFeePercentage: 0,
  };
}

export const AgreementInfoReply = {
  encode(message: AgreementInfoReply, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.agreementId !== 0) {
      writer.uint32(8).int32(message.agreementId);
    }
    if (message.clientNameInAgreement !== "") {
      writer.uint32(18).string(message.clientNameInAgreement);
    }
    if (message.contactEmails !== "") {
      writer.uint32(26).string(message.contactEmails);
    }
    for (const v of message.bindingChains) {
      BindingChain.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    if (message.agreementLink !== "") {
      writer.uint32(42).string(message.agreementLink);
    }
    if (message.agreementStatus !== "") {
      writer.uint32(50).string(message.agreementStatus);
    }
    if (message.agreementScope !== 0) {
      writer.uint32(56).int32(message.agreementScope);
    }
    if (message.paymentFrequency !== "") {
      writer.uint32(66).string(message.paymentFrequency);
    }
    if (message.amount !== 0) {
      writer.uint32(72).int32(message.amount);
    }
    if (message.notes !== "") {
      writer.uint32(82).string(message.notes);
    }
    if (message.billingStatus !== "") {
      writer.uint32(90).string(message.billingStatus);
    }
    if (message.clientName !== "") {
      writer.uint32(98).string(message.clientName);
    }
    if (message.withdrawFeePercentage !== 0) {
      writer.uint32(109).float(message.withdrawFeePercentage);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AgreementInfoReply {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAgreementInfoReply();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.agreementId = reader.int32();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.clientNameInAgreement = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.contactEmails = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.bindingChains.push(BindingChain.decode(reader, reader.uint32()));
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.agreementLink = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.agreementStatus = reader.string();
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.agreementScope = reader.int32();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.paymentFrequency = reader.string();
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.amount = reader.int32();
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.notes = reader.string();
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.billingStatus = reader.string();
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.clientName = reader.string();
          continue;
        case 13:
          if (tag !== 109) {
            break;
          }

          message.withdrawFeePercentage = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AgreementInfoReply {
    return {
      agreementId: isSet(object.agreementId) ? globalThis.Number(object.agreementId) : 0,
      clientNameInAgreement: isSet(object.clientNameInAgreement) ? globalThis.String(object.clientNameInAgreement) : "",
      contactEmails: isSet(object.contactEmails) ? globalThis.String(object.contactEmails) : "",
      bindingChains: globalThis.Array.isArray(object?.bindingChains)
        ? object.bindingChains.map((e: any) => BindingChain.fromJSON(e))
        : [],
      agreementLink: isSet(object.agreementLink) ? globalThis.String(object.agreementLink) : "",
      agreementStatus: isSet(object.agreementStatus) ? globalThis.String(object.agreementStatus) : "",
      agreementScope: isSet(object.agreementScope) ? globalThis.Number(object.agreementScope) : 0,
      paymentFrequency: isSet(object.paymentFrequency) ? globalThis.String(object.paymentFrequency) : "",
      amount: isSet(object.amount) ? globalThis.Number(object.amount) : 0,
      notes: isSet(object.notes) ? globalThis.String(object.notes) : "",
      billingStatus: isSet(object.billingStatus) ? globalThis.String(object.billingStatus) : "",
      clientName: isSet(object.clientName) ? globalThis.String(object.clientName) : "",
      withdrawFeePercentage: isSet(object.withdrawFeePercentage) ? globalThis.Number(object.withdrawFeePercentage) : 0,
    };
  },

  toJSON(message: AgreementInfoReply): unknown {
    const obj: any = {};
    if (message.agreementId !== 0) {
      obj.agreementId = Math.round(message.agreementId);
    }
    if (message.clientNameInAgreement !== "") {
      obj.clientNameInAgreement = message.clientNameInAgreement;
    }
    if (message.contactEmails !== "") {
      obj.contactEmails = message.contactEmails;
    }
    if (message.bindingChains?.length) {
      obj.bindingChains = message.bindingChains.map((e) => BindingChain.toJSON(e));
    }
    if (message.agreementLink !== "") {
      obj.agreementLink = message.agreementLink;
    }
    if (message.agreementStatus !== "") {
      obj.agreementStatus = message.agreementStatus;
    }
    if (message.agreementScope !== 0) {
      obj.agreementScope = Math.round(message.agreementScope);
    }
    if (message.paymentFrequency !== "") {
      obj.paymentFrequency = message.paymentFrequency;
    }
    if (message.amount !== 0) {
      obj.amount = Math.round(message.amount);
    }
    if (message.notes !== "") {
      obj.notes = message.notes;
    }
    if (message.billingStatus !== "") {
      obj.billingStatus = message.billingStatus;
    }
    if (message.clientName !== "") {
      obj.clientName = message.clientName;
    }
    if (message.withdrawFeePercentage !== 0) {
      obj.withdrawFeePercentage = message.withdrawFeePercentage;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AgreementInfoReply>, I>>(base?: I): AgreementInfoReply {
    return AgreementInfoReply.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AgreementInfoReply>, I>>(object: I): AgreementInfoReply {
    const message = createBaseAgreementInfoReply();
    message.agreementId = object.agreementId ?? 0;
    message.clientNameInAgreement = object.clientNameInAgreement ?? "";
    message.contactEmails = object.contactEmails ?? "";
    message.bindingChains = object.bindingChains?.map((e) => BindingChain.fromPartial(e)) || [];
    message.agreementLink = object.agreementLink ?? "";
    message.agreementStatus = object.agreementStatus ?? "";
    message.agreementScope = object.agreementScope ?? 0;
    message.paymentFrequency = object.paymentFrequency ?? "";
    message.amount = object.amount ?? 0;
    message.notes = object.notes ?? "";
    message.billingStatus = object.billingStatus ?? "";
    message.clientName = object.clientName ?? "";
    message.withdrawFeePercentage = object.withdrawFeePercentage ?? 0;
    return message;
  },
};

function createBaseBindingChain(): BindingChain {
  return { chainId: "", launchingDate: "", shutdownDate: "" };
}

export const BindingChain = {
  encode(message: BindingChain, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.chainId !== "") {
      writer.uint32(10).string(message.chainId);
    }
    if (message.launchingDate !== "") {
      writer.uint32(18).string(message.launchingDate);
    }
    if (message.shutdownDate !== "") {
      writer.uint32(26).string(message.shutdownDate);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): BindingChain {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBindingChain();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.chainId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.launchingDate = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.shutdownDate = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BindingChain {
    return {
      chainId: isSet(object.chainId) ? globalThis.String(object.chainId) : "",
      launchingDate: isSet(object.launchingDate) ? globalThis.String(object.launchingDate) : "",
      shutdownDate: isSet(object.shutdownDate) ? globalThis.String(object.shutdownDate) : "",
    };
  },

  toJSON(message: BindingChain): unknown {
    const obj: any = {};
    if (message.chainId !== "") {
      obj.chainId = message.chainId;
    }
    if (message.launchingDate !== "") {
      obj.launchingDate = message.launchingDate;
    }
    if (message.shutdownDate !== "") {
      obj.shutdownDate = message.shutdownDate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BindingChain>, I>>(base?: I): BindingChain {
    return BindingChain.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BindingChain>, I>>(object: I): BindingChain {
    const message = createBaseBindingChain();
    message.chainId = object.chainId ?? "";
    message.launchingDate = object.launchingDate ?? "";
    message.shutdownDate = object.shutdownDate ?? "";
    return message;
  },
};

function createBaseDeleteAgreementRequest(): DeleteAgreementRequest {
  return { agreementId: 0 };
}

export const DeleteAgreementRequest = {
  encode(message: DeleteAgreementRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.agreementId !== 0) {
      writer.uint32(8).int32(message.agreementId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DeleteAgreementRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteAgreementRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.agreementId = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteAgreementRequest {
    return { agreementId: isSet(object.agreementId) ? globalThis.Number(object.agreementId) : 0 };
  },

  toJSON(message: DeleteAgreementRequest): unknown {
    const obj: any = {};
    if (message.agreementId !== 0) {
      obj.agreementId = Math.round(message.agreementId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteAgreementRequest>, I>>(base?: I): DeleteAgreementRequest {
    return DeleteAgreementRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteAgreementRequest>, I>>(object: I): DeleteAgreementRequest {
    const message = createBaseDeleteAgreementRequest();
    message.agreementId = object.agreementId ?? 0;
    return message;
  },
};

function createBaseDeleteAgreementReply(): DeleteAgreementReply {
  return {};
}

export const DeleteAgreementReply = {
  encode(_: DeleteAgreementReply, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DeleteAgreementReply {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteAgreementReply();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): DeleteAgreementReply {
    return {};
  },

  toJSON(_: DeleteAgreementReply): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteAgreementReply>, I>>(base?: I): DeleteAgreementReply {
    return DeleteAgreementReply.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteAgreementReply>, I>>(_: I): DeleteAgreementReply {
    const message = createBaseDeleteAgreementReply();
    return message;
  },
};

function createBasePaymentTrackerRequest(): PaymentTrackerRequest {
  return { agreementId: 0 };
}

export const PaymentTrackerRequest = {
  encode(message: PaymentTrackerRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.agreementId !== 0) {
      writer.uint32(8).int32(message.agreementId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PaymentTrackerRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePaymentTrackerRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.agreementId = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PaymentTrackerRequest {
    return { agreementId: isSet(object.agreementId) ? globalThis.Number(object.agreementId) : 0 };
  },

  toJSON(message: PaymentTrackerRequest): unknown {
    const obj: any = {};
    if (message.agreementId !== 0) {
      obj.agreementId = Math.round(message.agreementId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PaymentTrackerRequest>, I>>(base?: I): PaymentTrackerRequest {
    return PaymentTrackerRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PaymentTrackerRequest>, I>>(object: I): PaymentTrackerRequest {
    const message = createBasePaymentTrackerRequest();
    message.agreementId = object.agreementId ?? 0;
    return message;
  },
};

function createBasePaymentTrackerReply(): PaymentTrackerReply {
  return { serviceFee: undefined, withdrawFee: undefined, otherFee: undefined };
}

export const PaymentTrackerReply = {
  encode(message: PaymentTrackerReply, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.serviceFee !== undefined) {
      ServiceFeeTracker.encode(message.serviceFee, writer.uint32(10).fork()).ldelim();
    }
    if (message.withdrawFee !== undefined) {
      WithdrawFeeTracker.encode(message.withdrawFee, writer.uint32(18).fork()).ldelim();
    }
    if (message.otherFee !== undefined) {
      OtherFeeTracker.encode(message.otherFee, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PaymentTrackerReply {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePaymentTrackerReply();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.serviceFee = ServiceFeeTracker.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.withdrawFee = WithdrawFeeTracker.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.otherFee = OtherFeeTracker.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PaymentTrackerReply {
    return {
      serviceFee: isSet(object.serviceFee) ? ServiceFeeTracker.fromJSON(object.serviceFee) : undefined,
      withdrawFee: isSet(object.withdrawFee) ? WithdrawFeeTracker.fromJSON(object.withdrawFee) : undefined,
      otherFee: isSet(object.otherFee) ? OtherFeeTracker.fromJSON(object.otherFee) : undefined,
    };
  },

  toJSON(message: PaymentTrackerReply): unknown {
    const obj: any = {};
    if (message.serviceFee !== undefined) {
      obj.serviceFee = ServiceFeeTracker.toJSON(message.serviceFee);
    }
    if (message.withdrawFee !== undefined) {
      obj.withdrawFee = WithdrawFeeTracker.toJSON(message.withdrawFee);
    }
    if (message.otherFee !== undefined) {
      obj.otherFee = OtherFeeTracker.toJSON(message.otherFee);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PaymentTrackerReply>, I>>(base?: I): PaymentTrackerReply {
    return PaymentTrackerReply.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PaymentTrackerReply>, I>>(object: I): PaymentTrackerReply {
    const message = createBasePaymentTrackerReply();
    message.serviceFee = (object.serviceFee !== undefined && object.serviceFee !== null)
      ? ServiceFeeTracker.fromPartial(object.serviceFee)
      : undefined;
    message.withdrawFee = (object.withdrawFee !== undefined && object.withdrawFee !== null)
      ? WithdrawFeeTracker.fromPartial(object.withdrawFee)
      : undefined;
    message.otherFee = (object.otherFee !== undefined && object.otherFee !== null)
      ? OtherFeeTracker.fromPartial(object.otherFee)
      : undefined;
    return message;
  },
};

function createBaseServiceFeeTracker(): ServiceFeeTracker {
  return { status: "", paymentPeriodFrom: "", paymentPeriodTo: "", balance: "" };
}

export const ServiceFeeTracker = {
  encode(message: ServiceFeeTracker, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.status !== "") {
      writer.uint32(10).string(message.status);
    }
    if (message.paymentPeriodFrom !== "") {
      writer.uint32(18).string(message.paymentPeriodFrom);
    }
    if (message.paymentPeriodTo !== "") {
      writer.uint32(26).string(message.paymentPeriodTo);
    }
    if (message.balance !== "") {
      writer.uint32(34).string(message.balance);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ServiceFeeTracker {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServiceFeeTracker();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.status = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.paymentPeriodFrom = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.paymentPeriodTo = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.balance = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServiceFeeTracker {
    return {
      status: isSet(object.status) ? globalThis.String(object.status) : "",
      paymentPeriodFrom: isSet(object.paymentPeriodFrom) ? globalThis.String(object.paymentPeriodFrom) : "",
      paymentPeriodTo: isSet(object.paymentPeriodTo) ? globalThis.String(object.paymentPeriodTo) : "",
      balance: isSet(object.balance) ? globalThis.String(object.balance) : "",
    };
  },

  toJSON(message: ServiceFeeTracker): unknown {
    const obj: any = {};
    if (message.status !== "") {
      obj.status = message.status;
    }
    if (message.paymentPeriodFrom !== "") {
      obj.paymentPeriodFrom = message.paymentPeriodFrom;
    }
    if (message.paymentPeriodTo !== "") {
      obj.paymentPeriodTo = message.paymentPeriodTo;
    }
    if (message.balance !== "") {
      obj.balance = message.balance;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServiceFeeTracker>, I>>(base?: I): ServiceFeeTracker {
    return ServiceFeeTracker.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServiceFeeTracker>, I>>(object: I): ServiceFeeTracker {
    const message = createBaseServiceFeeTracker();
    message.status = object.status ?? "";
    message.paymentPeriodFrom = object.paymentPeriodFrom ?? "";
    message.paymentPeriodTo = object.paymentPeriodTo ?? "";
    message.balance = object.balance ?? "";
    return message;
  },
};

function createBaseWithdrawFeeTracker(): WithdrawFeeTracker {
  return { status: "", paymentPeriodFrom: "", paymentPeriodTo: "", overdraft: "", currency: "" };
}

export const WithdrawFeeTracker = {
  encode(message: WithdrawFeeTracker, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.status !== "") {
      writer.uint32(10).string(message.status);
    }
    if (message.paymentPeriodFrom !== "") {
      writer.uint32(18).string(message.paymentPeriodFrom);
    }
    if (message.paymentPeriodTo !== "") {
      writer.uint32(26).string(message.paymentPeriodTo);
    }
    if (message.overdraft !== "") {
      writer.uint32(34).string(message.overdraft);
    }
    if (message.currency !== "") {
      writer.uint32(42).string(message.currency);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WithdrawFeeTracker {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWithdrawFeeTracker();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.status = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.paymentPeriodFrom = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.paymentPeriodTo = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.overdraft = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.currency = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WithdrawFeeTracker {
    return {
      status: isSet(object.status) ? globalThis.String(object.status) : "",
      paymentPeriodFrom: isSet(object.paymentPeriodFrom) ? globalThis.String(object.paymentPeriodFrom) : "",
      paymentPeriodTo: isSet(object.paymentPeriodTo) ? globalThis.String(object.paymentPeriodTo) : "",
      overdraft: isSet(object.overdraft) ? globalThis.String(object.overdraft) : "",
      currency: isSet(object.currency) ? globalThis.String(object.currency) : "",
    };
  },

  toJSON(message: WithdrawFeeTracker): unknown {
    const obj: any = {};
    if (message.status !== "") {
      obj.status = message.status;
    }
    if (message.paymentPeriodFrom !== "") {
      obj.paymentPeriodFrom = message.paymentPeriodFrom;
    }
    if (message.paymentPeriodTo !== "") {
      obj.paymentPeriodTo = message.paymentPeriodTo;
    }
    if (message.overdraft !== "") {
      obj.overdraft = message.overdraft;
    }
    if (message.currency !== "") {
      obj.currency = message.currency;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WithdrawFeeTracker>, I>>(base?: I): WithdrawFeeTracker {
    return WithdrawFeeTracker.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WithdrawFeeTracker>, I>>(object: I): WithdrawFeeTracker {
    const message = createBaseWithdrawFeeTracker();
    message.status = object.status ?? "";
    message.paymentPeriodFrom = object.paymentPeriodFrom ?? "";
    message.paymentPeriodTo = object.paymentPeriodTo ?? "";
    message.overdraft = object.overdraft ?? "";
    message.currency = object.currency ?? "";
    return message;
  },
};

function createBaseOtherFeeTracker(): OtherFeeTracker {
  return { subType: "", status: "", amount: "", currency: "" };
}

export const OtherFeeTracker = {
  encode(message: OtherFeeTracker, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.subType !== "") {
      writer.uint32(10).string(message.subType);
    }
    if (message.status !== "") {
      writer.uint32(18).string(message.status);
    }
    if (message.amount !== "") {
      writer.uint32(26).string(message.amount);
    }
    if (message.currency !== "") {
      writer.uint32(34).string(message.currency);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OtherFeeTracker {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOtherFeeTracker();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.subType = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.status = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.amount = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.currency = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OtherFeeTracker {
    return {
      subType: isSet(object.subType) ? globalThis.String(object.subType) : "",
      status: isSet(object.status) ? globalThis.String(object.status) : "",
      amount: isSet(object.amount) ? globalThis.String(object.amount) : "",
      currency: isSet(object.currency) ? globalThis.String(object.currency) : "",
    };
  },

  toJSON(message: OtherFeeTracker): unknown {
    const obj: any = {};
    if (message.subType !== "") {
      obj.subType = message.subType;
    }
    if (message.status !== "") {
      obj.status = message.status;
    }
    if (message.amount !== "") {
      obj.amount = message.amount;
    }
    if (message.currency !== "") {
      obj.currency = message.currency;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OtherFeeTracker>, I>>(base?: I): OtherFeeTracker {
    return OtherFeeTracker.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OtherFeeTracker>, I>>(object: I): OtherFeeTracker {
    const message = createBaseOtherFeeTracker();
    message.subType = object.subType ?? "";
    message.status = object.status ?? "";
    message.amount = object.amount ?? "";
    message.currency = object.currency ?? "";
    return message;
  },
};

function createBasePaymentListRequest(): PaymentListRequest {
  return { agreementId: 0, type: "" };
}

export const PaymentListRequest = {
  encode(message: PaymentListRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.agreementId !== 0) {
      writer.uint32(8).int32(message.agreementId);
    }
    if (message.type !== "") {
      writer.uint32(18).string(message.type);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PaymentListRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePaymentListRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.agreementId = reader.int32();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.type = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PaymentListRequest {
    return {
      agreementId: isSet(object.agreementId) ? globalThis.Number(object.agreementId) : 0,
      type: isSet(object.type) ? globalThis.String(object.type) : "",
    };
  },

  toJSON(message: PaymentListRequest): unknown {
    const obj: any = {};
    if (message.agreementId !== 0) {
      obj.agreementId = Math.round(message.agreementId);
    }
    if (message.type !== "") {
      obj.type = message.type;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PaymentListRequest>, I>>(base?: I): PaymentListRequest {
    return PaymentListRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PaymentListRequest>, I>>(object: I): PaymentListRequest {
    const message = createBasePaymentListRequest();
    message.agreementId = object.agreementId ?? 0;
    message.type = object.type ?? "";
    return message;
  },
};

function createBasePaymentListReply(): PaymentListReply {
  return { paymentInfo: [] };
}

export const PaymentListReply = {
  encode(message: PaymentListReply, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.paymentInfo) {
      SimplePaymentInfo.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PaymentListReply {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePaymentListReply();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.paymentInfo.push(SimplePaymentInfo.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PaymentListReply {
    return {
      paymentInfo: globalThis.Array.isArray(object?.paymentInfo)
        ? object.paymentInfo.map((e: any) => SimplePaymentInfo.fromJSON(e))
        : [],
    };
  },

  toJSON(message: PaymentListReply): unknown {
    const obj: any = {};
    if (message.paymentInfo?.length) {
      obj.paymentInfo = message.paymentInfo.map((e) => SimplePaymentInfo.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PaymentListReply>, I>>(base?: I): PaymentListReply {
    return PaymentListReply.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PaymentListReply>, I>>(object: I): PaymentListReply {
    const message = createBasePaymentListReply();
    message.paymentInfo = object.paymentInfo?.map((e) => SimplePaymentInfo.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSimplePaymentInfo(): SimplePaymentInfo {
  return {
    agreementId: 0,
    type: "",
    subType: "",
    amount: "",
    currency: "",
    status: "",
    invoiceTime: "",
    paymentTime: "",
    paymentTxhash: "",
    paymentId: 0,
  };
}

export const SimplePaymentInfo = {
  encode(message: SimplePaymentInfo, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.agreementId !== 0) {
      writer.uint32(8).int32(message.agreementId);
    }
    if (message.type !== "") {
      writer.uint32(18).string(message.type);
    }
    if (message.subType !== "") {
      writer.uint32(26).string(message.subType);
    }
    if (message.amount !== "") {
      writer.uint32(34).string(message.amount);
    }
    if (message.currency !== "") {
      writer.uint32(42).string(message.currency);
    }
    if (message.status !== "") {
      writer.uint32(50).string(message.status);
    }
    if (message.invoiceTime !== "") {
      writer.uint32(58).string(message.invoiceTime);
    }
    if (message.paymentTime !== "") {
      writer.uint32(66).string(message.paymentTime);
    }
    if (message.paymentTxhash !== "") {
      writer.uint32(74).string(message.paymentTxhash);
    }
    if (message.paymentId !== 0) {
      writer.uint32(80).int32(message.paymentId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SimplePaymentInfo {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSimplePaymentInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.agreementId = reader.int32();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.type = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.subType = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.amount = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.currency = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.status = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.invoiceTime = reader.string();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.paymentTime = reader.string();
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.paymentTxhash = reader.string();
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.paymentId = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SimplePaymentInfo {
    return {
      agreementId: isSet(object.agreementId) ? globalThis.Number(object.agreementId) : 0,
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      subType: isSet(object.subType) ? globalThis.String(object.subType) : "",
      amount: isSet(object.amount) ? globalThis.String(object.amount) : "",
      currency: isSet(object.currency) ? globalThis.String(object.currency) : "",
      status: isSet(object.status) ? globalThis.String(object.status) : "",
      invoiceTime: isSet(object.invoiceTime) ? globalThis.String(object.invoiceTime) : "",
      paymentTime: isSet(object.paymentTime) ? globalThis.String(object.paymentTime) : "",
      paymentTxhash: isSet(object.paymentTxhash) ? globalThis.String(object.paymentTxhash) : "",
      paymentId: isSet(object.paymentId) ? globalThis.Number(object.paymentId) : 0,
    };
  },

  toJSON(message: SimplePaymentInfo): unknown {
    const obj: any = {};
    if (message.agreementId !== 0) {
      obj.agreementId = Math.round(message.agreementId);
    }
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.subType !== "") {
      obj.subType = message.subType;
    }
    if (message.amount !== "") {
      obj.amount = message.amount;
    }
    if (message.currency !== "") {
      obj.currency = message.currency;
    }
    if (message.status !== "") {
      obj.status = message.status;
    }
    if (message.invoiceTime !== "") {
      obj.invoiceTime = message.invoiceTime;
    }
    if (message.paymentTime !== "") {
      obj.paymentTime = message.paymentTime;
    }
    if (message.paymentTxhash !== "") {
      obj.paymentTxhash = message.paymentTxhash;
    }
    if (message.paymentId !== 0) {
      obj.paymentId = Math.round(message.paymentId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SimplePaymentInfo>, I>>(base?: I): SimplePaymentInfo {
    return SimplePaymentInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SimplePaymentInfo>, I>>(object: I): SimplePaymentInfo {
    const message = createBaseSimplePaymentInfo();
    message.agreementId = object.agreementId ?? 0;
    message.type = object.type ?? "";
    message.subType = object.subType ?? "";
    message.amount = object.amount ?? "";
    message.currency = object.currency ?? "";
    message.status = object.status ?? "";
    message.invoiceTime = object.invoiceTime ?? "";
    message.paymentTime = object.paymentTime ?? "";
    message.paymentTxhash = object.paymentTxhash ?? "";
    message.paymentId = object.paymentId ?? 0;
    return message;
  },
};

function createBaseCreatePaymentRequest(): CreatePaymentRequest {
  return {
    agreementId: 0,
    type: "",
    subType: "",
    amount: "",
    currency: "",
    status: "",
    paymentPeriodFrom: "",
    paymentPeriodTo: "",
    nextPaymentDate: "",
    invoiceTime: "",
    paymentTime: "",
    paymentTxhash: "",
  };
}

export const CreatePaymentRequest = {
  encode(message: CreatePaymentRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.agreementId !== 0) {
      writer.uint32(8).int32(message.agreementId);
    }
    if (message.type !== "") {
      writer.uint32(18).string(message.type);
    }
    if (message.subType !== "") {
      writer.uint32(26).string(message.subType);
    }
    if (message.amount !== "") {
      writer.uint32(34).string(message.amount);
    }
    if (message.currency !== "") {
      writer.uint32(42).string(message.currency);
    }
    if (message.status !== "") {
      writer.uint32(50).string(message.status);
    }
    if (message.paymentPeriodFrom !== "") {
      writer.uint32(58).string(message.paymentPeriodFrom);
    }
    if (message.paymentPeriodTo !== "") {
      writer.uint32(66).string(message.paymentPeriodTo);
    }
    if (message.nextPaymentDate !== "") {
      writer.uint32(74).string(message.nextPaymentDate);
    }
    if (message.invoiceTime !== "") {
      writer.uint32(82).string(message.invoiceTime);
    }
    if (message.paymentTime !== "") {
      writer.uint32(90).string(message.paymentTime);
    }
    if (message.paymentTxhash !== "") {
      writer.uint32(98).string(message.paymentTxhash);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CreatePaymentRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreatePaymentRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.agreementId = reader.int32();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.type = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.subType = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.amount = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.currency = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.status = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.paymentPeriodFrom = reader.string();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.paymentPeriodTo = reader.string();
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.nextPaymentDate = reader.string();
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.invoiceTime = reader.string();
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.paymentTime = reader.string();
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.paymentTxhash = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreatePaymentRequest {
    return {
      agreementId: isSet(object.agreementId) ? globalThis.Number(object.agreementId) : 0,
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      subType: isSet(object.subType) ? globalThis.String(object.subType) : "",
      amount: isSet(object.amount) ? globalThis.String(object.amount) : "",
      currency: isSet(object.currency) ? globalThis.String(object.currency) : "",
      status: isSet(object.status) ? globalThis.String(object.status) : "",
      paymentPeriodFrom: isSet(object.paymentPeriodFrom) ? globalThis.String(object.paymentPeriodFrom) : "",
      paymentPeriodTo: isSet(object.paymentPeriodTo) ? globalThis.String(object.paymentPeriodTo) : "",
      nextPaymentDate: isSet(object.nextPaymentDate) ? globalThis.String(object.nextPaymentDate) : "",
      invoiceTime: isSet(object.invoiceTime) ? globalThis.String(object.invoiceTime) : "",
      paymentTime: isSet(object.paymentTime) ? globalThis.String(object.paymentTime) : "",
      paymentTxhash: isSet(object.paymentTxhash) ? globalThis.String(object.paymentTxhash) : "",
    };
  },

  toJSON(message: CreatePaymentRequest): unknown {
    const obj: any = {};
    if (message.agreementId !== 0) {
      obj.agreementId = Math.round(message.agreementId);
    }
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.subType !== "") {
      obj.subType = message.subType;
    }
    if (message.amount !== "") {
      obj.amount = message.amount;
    }
    if (message.currency !== "") {
      obj.currency = message.currency;
    }
    if (message.status !== "") {
      obj.status = message.status;
    }
    if (message.paymentPeriodFrom !== "") {
      obj.paymentPeriodFrom = message.paymentPeriodFrom;
    }
    if (message.paymentPeriodTo !== "") {
      obj.paymentPeriodTo = message.paymentPeriodTo;
    }
    if (message.nextPaymentDate !== "") {
      obj.nextPaymentDate = message.nextPaymentDate;
    }
    if (message.invoiceTime !== "") {
      obj.invoiceTime = message.invoiceTime;
    }
    if (message.paymentTime !== "") {
      obj.paymentTime = message.paymentTime;
    }
    if (message.paymentTxhash !== "") {
      obj.paymentTxhash = message.paymentTxhash;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreatePaymentRequest>, I>>(base?: I): CreatePaymentRequest {
    return CreatePaymentRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreatePaymentRequest>, I>>(object: I): CreatePaymentRequest {
    const message = createBaseCreatePaymentRequest();
    message.agreementId = object.agreementId ?? 0;
    message.type = object.type ?? "";
    message.subType = object.subType ?? "";
    message.amount = object.amount ?? "";
    message.currency = object.currency ?? "";
    message.status = object.status ?? "";
    message.paymentPeriodFrom = object.paymentPeriodFrom ?? "";
    message.paymentPeriodTo = object.paymentPeriodTo ?? "";
    message.nextPaymentDate = object.nextPaymentDate ?? "";
    message.invoiceTime = object.invoiceTime ?? "";
    message.paymentTime = object.paymentTime ?? "";
    message.paymentTxhash = object.paymentTxhash ?? "";
    return message;
  },
};

function createBaseCreatePaymentReply(): CreatePaymentReply {
  return {};
}

export const CreatePaymentReply = {
  encode(_: CreatePaymentReply, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CreatePaymentReply {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreatePaymentReply();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): CreatePaymentReply {
    return {};
  },

  toJSON(_: CreatePaymentReply): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<CreatePaymentReply>, I>>(base?: I): CreatePaymentReply {
    return CreatePaymentReply.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreatePaymentReply>, I>>(_: I): CreatePaymentReply {
    const message = createBaseCreatePaymentReply();
    return message;
  },
};

function createBaseEditPaymentRequest(): EditPaymentRequest {
  return {
    paymentId: 0,
    agreementId: 0,
    type: "",
    subType: "",
    amount: "",
    currency: "",
    status: "",
    paymentPeriodFrom: "",
    paymentPeriodTo: "",
    nextPaymentDate: "",
    invoiceTime: "",
    paymentTime: "",
    paymentTxhash: "",
  };
}

export const EditPaymentRequest = {
  encode(message: EditPaymentRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.paymentId !== 0) {
      writer.uint32(8).int32(message.paymentId);
    }
    if (message.agreementId !== 0) {
      writer.uint32(16).int32(message.agreementId);
    }
    if (message.type !== "") {
      writer.uint32(26).string(message.type);
    }
    if (message.subType !== "") {
      writer.uint32(34).string(message.subType);
    }
    if (message.amount !== "") {
      writer.uint32(42).string(message.amount);
    }
    if (message.currency !== "") {
      writer.uint32(50).string(message.currency);
    }
    if (message.status !== "") {
      writer.uint32(58).string(message.status);
    }
    if (message.paymentPeriodFrom !== "") {
      writer.uint32(66).string(message.paymentPeriodFrom);
    }
    if (message.paymentPeriodTo !== "") {
      writer.uint32(74).string(message.paymentPeriodTo);
    }
    if (message.nextPaymentDate !== "") {
      writer.uint32(82).string(message.nextPaymentDate);
    }
    if (message.invoiceTime !== "") {
      writer.uint32(90).string(message.invoiceTime);
    }
    if (message.paymentTime !== "") {
      writer.uint32(98).string(message.paymentTime);
    }
    if (message.paymentTxhash !== "") {
      writer.uint32(106).string(message.paymentTxhash);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): EditPaymentRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEditPaymentRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.paymentId = reader.int32();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.agreementId = reader.int32();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.type = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.subType = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.amount = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.currency = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.status = reader.string();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.paymentPeriodFrom = reader.string();
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.paymentPeriodTo = reader.string();
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.nextPaymentDate = reader.string();
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.invoiceTime = reader.string();
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.paymentTime = reader.string();
          continue;
        case 13:
          if (tag !== 106) {
            break;
          }

          message.paymentTxhash = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EditPaymentRequest {
    return {
      paymentId: isSet(object.paymentId) ? globalThis.Number(object.paymentId) : 0,
      agreementId: isSet(object.agreementId) ? globalThis.Number(object.agreementId) : 0,
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      subType: isSet(object.subType) ? globalThis.String(object.subType) : "",
      amount: isSet(object.amount) ? globalThis.String(object.amount) : "",
      currency: isSet(object.currency) ? globalThis.String(object.currency) : "",
      status: isSet(object.status) ? globalThis.String(object.status) : "",
      paymentPeriodFrom: isSet(object.paymentPeriodFrom) ? globalThis.String(object.paymentPeriodFrom) : "",
      paymentPeriodTo: isSet(object.paymentPeriodTo) ? globalThis.String(object.paymentPeriodTo) : "",
      nextPaymentDate: isSet(object.nextPaymentDate) ? globalThis.String(object.nextPaymentDate) : "",
      invoiceTime: isSet(object.invoiceTime) ? globalThis.String(object.invoiceTime) : "",
      paymentTime: isSet(object.paymentTime) ? globalThis.String(object.paymentTime) : "",
      paymentTxhash: isSet(object.paymentTxhash) ? globalThis.String(object.paymentTxhash) : "",
    };
  },

  toJSON(message: EditPaymentRequest): unknown {
    const obj: any = {};
    if (message.paymentId !== 0) {
      obj.paymentId = Math.round(message.paymentId);
    }
    if (message.agreementId !== 0) {
      obj.agreementId = Math.round(message.agreementId);
    }
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.subType !== "") {
      obj.subType = message.subType;
    }
    if (message.amount !== "") {
      obj.amount = message.amount;
    }
    if (message.currency !== "") {
      obj.currency = message.currency;
    }
    if (message.status !== "") {
      obj.status = message.status;
    }
    if (message.paymentPeriodFrom !== "") {
      obj.paymentPeriodFrom = message.paymentPeriodFrom;
    }
    if (message.paymentPeriodTo !== "") {
      obj.paymentPeriodTo = message.paymentPeriodTo;
    }
    if (message.nextPaymentDate !== "") {
      obj.nextPaymentDate = message.nextPaymentDate;
    }
    if (message.invoiceTime !== "") {
      obj.invoiceTime = message.invoiceTime;
    }
    if (message.paymentTime !== "") {
      obj.paymentTime = message.paymentTime;
    }
    if (message.paymentTxhash !== "") {
      obj.paymentTxhash = message.paymentTxhash;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EditPaymentRequest>, I>>(base?: I): EditPaymentRequest {
    return EditPaymentRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EditPaymentRequest>, I>>(object: I): EditPaymentRequest {
    const message = createBaseEditPaymentRequest();
    message.paymentId = object.paymentId ?? 0;
    message.agreementId = object.agreementId ?? 0;
    message.type = object.type ?? "";
    message.subType = object.subType ?? "";
    message.amount = object.amount ?? "";
    message.currency = object.currency ?? "";
    message.status = object.status ?? "";
    message.paymentPeriodFrom = object.paymentPeriodFrom ?? "";
    message.paymentPeriodTo = object.paymentPeriodTo ?? "";
    message.nextPaymentDate = object.nextPaymentDate ?? "";
    message.invoiceTime = object.invoiceTime ?? "";
    message.paymentTime = object.paymentTime ?? "";
    message.paymentTxhash = object.paymentTxhash ?? "";
    return message;
  },
};

function createBaseEditPaymentReply(): EditPaymentReply {
  return {};
}

export const EditPaymentReply = {
  encode(_: EditPaymentReply, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): EditPaymentReply {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEditPaymentReply();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): EditPaymentReply {
    return {};
  },

  toJSON(_: EditPaymentReply): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<EditPaymentReply>, I>>(base?: I): EditPaymentReply {
    return EditPaymentReply.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EditPaymentReply>, I>>(_: I): EditPaymentReply {
    const message = createBaseEditPaymentReply();
    return message;
  },
};

function createBasePaymentInfoRequest(): PaymentInfoRequest {
  return { paymentId: 0 };
}

export const PaymentInfoRequest = {
  encode(message: PaymentInfoRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.paymentId !== 0) {
      writer.uint32(8).int32(message.paymentId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PaymentInfoRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePaymentInfoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.paymentId = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PaymentInfoRequest {
    return { paymentId: isSet(object.paymentId) ? globalThis.Number(object.paymentId) : 0 };
  },

  toJSON(message: PaymentInfoRequest): unknown {
    const obj: any = {};
    if (message.paymentId !== 0) {
      obj.paymentId = Math.round(message.paymentId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PaymentInfoRequest>, I>>(base?: I): PaymentInfoRequest {
    return PaymentInfoRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PaymentInfoRequest>, I>>(object: I): PaymentInfoRequest {
    const message = createBasePaymentInfoRequest();
    message.paymentId = object.paymentId ?? 0;
    return message;
  },
};

function createBasePaymentInfoReply(): PaymentInfoReply {
  return {
    agreementId: 0,
    paymentId: 0,
    type: "",
    subType: "",
    amount: "",
    currency: "",
    status: "",
    paymentPeriodFrom: "",
    paymentPeriodTo: "",
    nextPaymentDate: "",
    invoiceTime: "",
    paymentTime: "",
    paymentTxhash: "",
  };
}

export const PaymentInfoReply = {
  encode(message: PaymentInfoReply, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.agreementId !== 0) {
      writer.uint32(8).int32(message.agreementId);
    }
    if (message.paymentId !== 0) {
      writer.uint32(16).int32(message.paymentId);
    }
    if (message.type !== "") {
      writer.uint32(26).string(message.type);
    }
    if (message.subType !== "") {
      writer.uint32(34).string(message.subType);
    }
    if (message.amount !== "") {
      writer.uint32(42).string(message.amount);
    }
    if (message.currency !== "") {
      writer.uint32(50).string(message.currency);
    }
    if (message.status !== "") {
      writer.uint32(58).string(message.status);
    }
    if (message.paymentPeriodFrom !== "") {
      writer.uint32(66).string(message.paymentPeriodFrom);
    }
    if (message.paymentPeriodTo !== "") {
      writer.uint32(74).string(message.paymentPeriodTo);
    }
    if (message.nextPaymentDate !== "") {
      writer.uint32(82).string(message.nextPaymentDate);
    }
    if (message.invoiceTime !== "") {
      writer.uint32(90).string(message.invoiceTime);
    }
    if (message.paymentTime !== "") {
      writer.uint32(98).string(message.paymentTime);
    }
    if (message.paymentTxhash !== "") {
      writer.uint32(106).string(message.paymentTxhash);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PaymentInfoReply {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePaymentInfoReply();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.agreementId = reader.int32();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.paymentId = reader.int32();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.type = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.subType = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.amount = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.currency = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.status = reader.string();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.paymentPeriodFrom = reader.string();
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.paymentPeriodTo = reader.string();
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.nextPaymentDate = reader.string();
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.invoiceTime = reader.string();
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.paymentTime = reader.string();
          continue;
        case 13:
          if (tag !== 106) {
            break;
          }

          message.paymentTxhash = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PaymentInfoReply {
    return {
      agreementId: isSet(object.agreementId) ? globalThis.Number(object.agreementId) : 0,
      paymentId: isSet(object.paymentId) ? globalThis.Number(object.paymentId) : 0,
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      subType: isSet(object.subType) ? globalThis.String(object.subType) : "",
      amount: isSet(object.amount) ? globalThis.String(object.amount) : "",
      currency: isSet(object.currency) ? globalThis.String(object.currency) : "",
      status: isSet(object.status) ? globalThis.String(object.status) : "",
      paymentPeriodFrom: isSet(object.paymentPeriodFrom) ? globalThis.String(object.paymentPeriodFrom) : "",
      paymentPeriodTo: isSet(object.paymentPeriodTo) ? globalThis.String(object.paymentPeriodTo) : "",
      nextPaymentDate: isSet(object.nextPaymentDate) ? globalThis.String(object.nextPaymentDate) : "",
      invoiceTime: isSet(object.invoiceTime) ? globalThis.String(object.invoiceTime) : "",
      paymentTime: isSet(object.paymentTime) ? globalThis.String(object.paymentTime) : "",
      paymentTxhash: isSet(object.paymentTxhash) ? globalThis.String(object.paymentTxhash) : "",
    };
  },

  toJSON(message: PaymentInfoReply): unknown {
    const obj: any = {};
    if (message.agreementId !== 0) {
      obj.agreementId = Math.round(message.agreementId);
    }
    if (message.paymentId !== 0) {
      obj.paymentId = Math.round(message.paymentId);
    }
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.subType !== "") {
      obj.subType = message.subType;
    }
    if (message.amount !== "") {
      obj.amount = message.amount;
    }
    if (message.currency !== "") {
      obj.currency = message.currency;
    }
    if (message.status !== "") {
      obj.status = message.status;
    }
    if (message.paymentPeriodFrom !== "") {
      obj.paymentPeriodFrom = message.paymentPeriodFrom;
    }
    if (message.paymentPeriodTo !== "") {
      obj.paymentPeriodTo = message.paymentPeriodTo;
    }
    if (message.nextPaymentDate !== "") {
      obj.nextPaymentDate = message.nextPaymentDate;
    }
    if (message.invoiceTime !== "") {
      obj.invoiceTime = message.invoiceTime;
    }
    if (message.paymentTime !== "") {
      obj.paymentTime = message.paymentTime;
    }
    if (message.paymentTxhash !== "") {
      obj.paymentTxhash = message.paymentTxhash;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PaymentInfoReply>, I>>(base?: I): PaymentInfoReply {
    return PaymentInfoReply.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PaymentInfoReply>, I>>(object: I): PaymentInfoReply {
    const message = createBasePaymentInfoReply();
    message.agreementId = object.agreementId ?? 0;
    message.paymentId = object.paymentId ?? 0;
    message.type = object.type ?? "";
    message.subType = object.subType ?? "";
    message.amount = object.amount ?? "";
    message.currency = object.currency ?? "";
    message.status = object.status ?? "";
    message.paymentPeriodFrom = object.paymentPeriodFrom ?? "";
    message.paymentPeriodTo = object.paymentPeriodTo ?? "";
    message.nextPaymentDate = object.nextPaymentDate ?? "";
    message.invoiceTime = object.invoiceTime ?? "";
    message.paymentTime = object.paymentTime ?? "";
    message.paymentTxhash = object.paymentTxhash ?? "";
    return message;
  },
};

function createBaseDeletePaymentRequest(): DeletePaymentRequest {
  return { paymentId: 0 };
}

export const DeletePaymentRequest = {
  encode(message: DeletePaymentRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.paymentId !== 0) {
      writer.uint32(8).int32(message.paymentId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DeletePaymentRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeletePaymentRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.paymentId = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeletePaymentRequest {
    return { paymentId: isSet(object.paymentId) ? globalThis.Number(object.paymentId) : 0 };
  },

  toJSON(message: DeletePaymentRequest): unknown {
    const obj: any = {};
    if (message.paymentId !== 0) {
      obj.paymentId = Math.round(message.paymentId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeletePaymentRequest>, I>>(base?: I): DeletePaymentRequest {
    return DeletePaymentRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeletePaymentRequest>, I>>(object: I): DeletePaymentRequest {
    const message = createBaseDeletePaymentRequest();
    message.paymentId = object.paymentId ?? 0;
    return message;
  },
};

function createBaseDeletePaymentReply(): DeletePaymentReply {
  return {};
}

export const DeletePaymentReply = {
  encode(_: DeletePaymentReply, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DeletePaymentReply {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeletePaymentReply();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): DeletePaymentReply {
    return {};
  },

  toJSON(_: DeletePaymentReply): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<DeletePaymentReply>, I>>(base?: I): DeletePaymentReply {
    return DeletePaymentReply.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeletePaymentReply>, I>>(_: I): DeletePaymentReply {
    const message = createBaseDeletePaymentReply();
    return message;
  },
};

function createBaseWithdrawMonthlyBillRequest(): WithdrawMonthlyBillRequest {
  return { opstackId: "", billMonth: "" };
}

export const WithdrawMonthlyBillRequest = {
  encode(message: WithdrawMonthlyBillRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.opstackId !== "") {
      writer.uint32(10).string(message.opstackId);
    }
    if (message.billMonth !== "") {
      writer.uint32(18).string(message.billMonth);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WithdrawMonthlyBillRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWithdrawMonthlyBillRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.opstackId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.billMonth = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WithdrawMonthlyBillRequest {
    return {
      opstackId: isSet(object.opstackId) ? globalThis.String(object.opstackId) : "",
      billMonth: isSet(object.billMonth) ? globalThis.String(object.billMonth) : "",
    };
  },

  toJSON(message: WithdrawMonthlyBillRequest): unknown {
    const obj: any = {};
    if (message.opstackId !== "") {
      obj.opstackId = message.opstackId;
    }
    if (message.billMonth !== "") {
      obj.billMonth = message.billMonth;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WithdrawMonthlyBillRequest>, I>>(base?: I): WithdrawMonthlyBillRequest {
    return WithdrawMonthlyBillRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WithdrawMonthlyBillRequest>, I>>(object: I): WithdrawMonthlyBillRequest {
    const message = createBaseWithdrawMonthlyBillRequest();
    message.opstackId = object.opstackId ?? "";
    message.billMonth = object.billMonth ?? "";
    return message;
  },
};

function createBaseWithdrawMonthlyBillReply(): WithdrawMonthlyBillReply {
  return { withdrawBills: [] };
}

export const WithdrawMonthlyBillReply = {
  encode(message: WithdrawMonthlyBillReply, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.withdrawBills) {
      WithdrawBill.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WithdrawMonthlyBillReply {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWithdrawMonthlyBillReply();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.withdrawBills.push(WithdrawBill.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WithdrawMonthlyBillReply {
    return {
      withdrawBills: globalThis.Array.isArray(object?.withdrawBills)
        ? object.withdrawBills.map((e: any) => WithdrawBill.fromJSON(e))
        : [],
    };
  },

  toJSON(message: WithdrawMonthlyBillReply): unknown {
    const obj: any = {};
    if (message.withdrawBills?.length) {
      obj.withdrawBills = message.withdrawBills.map((e) => WithdrawBill.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WithdrawMonthlyBillReply>, I>>(base?: I): WithdrawMonthlyBillReply {
    return WithdrawMonthlyBillReply.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WithdrawMonthlyBillReply>, I>>(object: I): WithdrawMonthlyBillReply {
    const message = createBaseWithdrawMonthlyBillReply();
    message.withdrawBills = object.withdrawBills?.map((e) => WithdrawBill.fromPartial(e)) || [];
    return message;
  },
};

function createBaseWithdrawBill(): WithdrawBill {
  return {
    billMonth: "",
    totalFee: "",
    totalBaseFee: "",
    totalL1Fee: "",
    totalSequencerFee: "",
    altlayerFee: "",
    opFee: "",
    gasFee: "",
    earnings: "",
  };
}

export const WithdrawBill = {
  encode(message: WithdrawBill, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.billMonth !== "") {
      writer.uint32(10).string(message.billMonth);
    }
    if (message.totalFee !== "") {
      writer.uint32(18).string(message.totalFee);
    }
    if (message.totalBaseFee !== "") {
      writer.uint32(26).string(message.totalBaseFee);
    }
    if (message.totalL1Fee !== "") {
      writer.uint32(34).string(message.totalL1Fee);
    }
    if (message.totalSequencerFee !== "") {
      writer.uint32(42).string(message.totalSequencerFee);
    }
    if (message.altlayerFee !== "") {
      writer.uint32(50).string(message.altlayerFee);
    }
    if (message.opFee !== "") {
      writer.uint32(58).string(message.opFee);
    }
    if (message.gasFee !== "") {
      writer.uint32(66).string(message.gasFee);
    }
    if (message.earnings !== "") {
      writer.uint32(74).string(message.earnings);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WithdrawBill {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWithdrawBill();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.billMonth = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.totalFee = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.totalBaseFee = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.totalL1Fee = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.totalSequencerFee = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.altlayerFee = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.opFee = reader.string();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.gasFee = reader.string();
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.earnings = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WithdrawBill {
    return {
      billMonth: isSet(object.billMonth) ? globalThis.String(object.billMonth) : "",
      totalFee: isSet(object.totalFee) ? globalThis.String(object.totalFee) : "",
      totalBaseFee: isSet(object.totalBaseFee) ? globalThis.String(object.totalBaseFee) : "",
      totalL1Fee: isSet(object.totalL1Fee) ? globalThis.String(object.totalL1Fee) : "",
      totalSequencerFee: isSet(object.totalSequencerFee) ? globalThis.String(object.totalSequencerFee) : "",
      altlayerFee: isSet(object.altlayerFee) ? globalThis.String(object.altlayerFee) : "",
      opFee: isSet(object.opFee) ? globalThis.String(object.opFee) : "",
      gasFee: isSet(object.gasFee) ? globalThis.String(object.gasFee) : "",
      earnings: isSet(object.earnings) ? globalThis.String(object.earnings) : "",
    };
  },

  toJSON(message: WithdrawBill): unknown {
    const obj: any = {};
    if (message.billMonth !== "") {
      obj.billMonth = message.billMonth;
    }
    if (message.totalFee !== "") {
      obj.totalFee = message.totalFee;
    }
    if (message.totalBaseFee !== "") {
      obj.totalBaseFee = message.totalBaseFee;
    }
    if (message.totalL1Fee !== "") {
      obj.totalL1Fee = message.totalL1Fee;
    }
    if (message.totalSequencerFee !== "") {
      obj.totalSequencerFee = message.totalSequencerFee;
    }
    if (message.altlayerFee !== "") {
      obj.altlayerFee = message.altlayerFee;
    }
    if (message.opFee !== "") {
      obj.opFee = message.opFee;
    }
    if (message.gasFee !== "") {
      obj.gasFee = message.gasFee;
    }
    if (message.earnings !== "") {
      obj.earnings = message.earnings;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WithdrawBill>, I>>(base?: I): WithdrawBill {
    return WithdrawBill.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WithdrawBill>, I>>(object: I): WithdrawBill {
    const message = createBaseWithdrawBill();
    message.billMonth = object.billMonth ?? "";
    message.totalFee = object.totalFee ?? "";
    message.totalBaseFee = object.totalBaseFee ?? "";
    message.totalL1Fee = object.totalL1Fee ?? "";
    message.totalSequencerFee = object.totalSequencerFee ?? "";
    message.altlayerFee = object.altlayerFee ?? "";
    message.opFee = object.opFee ?? "";
    message.gasFee = object.gasFee ?? "";
    message.earnings = object.earnings ?? "";
    return message;
  },
};

function createBaseAgreementCostListRequest(): AgreementCostListRequest {
  return { agreementId: 0 };
}

export const AgreementCostListRequest = {
  encode(message: AgreementCostListRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.agreementId !== 0) {
      writer.uint32(8).int32(message.agreementId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AgreementCostListRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAgreementCostListRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.agreementId = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AgreementCostListRequest {
    return { agreementId: isSet(object.agreementId) ? globalThis.Number(object.agreementId) : 0 };
  },

  toJSON(message: AgreementCostListRequest): unknown {
    const obj: any = {};
    if (message.agreementId !== 0) {
      obj.agreementId = Math.round(message.agreementId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AgreementCostListRequest>, I>>(base?: I): AgreementCostListRequest {
    return AgreementCostListRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AgreementCostListRequest>, I>>(object: I): AgreementCostListRequest {
    const message = createBaseAgreementCostListRequest();
    message.agreementId = object.agreementId ?? 0;
    return message;
  },
};

function createBaseAgreementCostListReply(): AgreementCostListReply {
  return { costInfo: [] };
}

export const AgreementCostListReply = {
  encode(message: AgreementCostListReply, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.costInfo) {
      AgreementCostInfo.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AgreementCostListReply {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAgreementCostListReply();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.costInfo.push(AgreementCostInfo.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AgreementCostListReply {
    return {
      costInfo: globalThis.Array.isArray(object?.costInfo)
        ? object.costInfo.map((e: any) => AgreementCostInfo.fromJSON(e))
        : [],
    };
  },

  toJSON(message: AgreementCostListReply): unknown {
    const obj: any = {};
    if (message.costInfo?.length) {
      obj.costInfo = message.costInfo.map((e) => AgreementCostInfo.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AgreementCostListReply>, I>>(base?: I): AgreementCostListReply {
    return AgreementCostListReply.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AgreementCostListReply>, I>>(object: I): AgreementCostListReply {
    const message = createBaseAgreementCostListReply();
    message.costInfo = object.costInfo?.map((e) => AgreementCostInfo.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAgreementCostInfo(): AgreementCostInfo {
  return { agreementId: 0, costId: 0, amount: 0, currency: "", notes: "", month: "" };
}

export const AgreementCostInfo = {
  encode(message: AgreementCostInfo, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.agreementId !== 0) {
      writer.uint32(8).int32(message.agreementId);
    }
    if (message.costId !== 0) {
      writer.uint32(16).int32(message.costId);
    }
    if (message.amount !== 0) {
      writer.uint32(24).int32(message.amount);
    }
    if (message.currency !== "") {
      writer.uint32(34).string(message.currency);
    }
    if (message.notes !== "") {
      writer.uint32(42).string(message.notes);
    }
    if (message.month !== "") {
      writer.uint32(50).string(message.month);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AgreementCostInfo {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAgreementCostInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.agreementId = reader.int32();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.costId = reader.int32();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.amount = reader.int32();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.currency = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.notes = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.month = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AgreementCostInfo {
    return {
      agreementId: isSet(object.agreementId) ? globalThis.Number(object.agreementId) : 0,
      costId: isSet(object.costId) ? globalThis.Number(object.costId) : 0,
      amount: isSet(object.amount) ? globalThis.Number(object.amount) : 0,
      currency: isSet(object.currency) ? globalThis.String(object.currency) : "",
      notes: isSet(object.notes) ? globalThis.String(object.notes) : "",
      month: isSet(object.month) ? globalThis.String(object.month) : "",
    };
  },

  toJSON(message: AgreementCostInfo): unknown {
    const obj: any = {};
    if (message.agreementId !== 0) {
      obj.agreementId = Math.round(message.agreementId);
    }
    if (message.costId !== 0) {
      obj.costId = Math.round(message.costId);
    }
    if (message.amount !== 0) {
      obj.amount = Math.round(message.amount);
    }
    if (message.currency !== "") {
      obj.currency = message.currency;
    }
    if (message.notes !== "") {
      obj.notes = message.notes;
    }
    if (message.month !== "") {
      obj.month = message.month;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AgreementCostInfo>, I>>(base?: I): AgreementCostInfo {
    return AgreementCostInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AgreementCostInfo>, I>>(object: I): AgreementCostInfo {
    const message = createBaseAgreementCostInfo();
    message.agreementId = object.agreementId ?? 0;
    message.costId = object.costId ?? 0;
    message.amount = object.amount ?? 0;
    message.currency = object.currency ?? "";
    message.notes = object.notes ?? "";
    message.month = object.month ?? "";
    return message;
  },
};

function createBaseCreateAgreementCostRequest(): CreateAgreementCostRequest {
  return { agreementId: 0, amount: 0, currency: "", notes: "", month: "" };
}

export const CreateAgreementCostRequest = {
  encode(message: CreateAgreementCostRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.agreementId !== 0) {
      writer.uint32(8).int32(message.agreementId);
    }
    if (message.amount !== 0) {
      writer.uint32(16).int32(message.amount);
    }
    if (message.currency !== "") {
      writer.uint32(26).string(message.currency);
    }
    if (message.notes !== "") {
      writer.uint32(34).string(message.notes);
    }
    if (message.month !== "") {
      writer.uint32(42).string(message.month);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CreateAgreementCostRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateAgreementCostRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.agreementId = reader.int32();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.amount = reader.int32();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.currency = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.notes = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.month = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateAgreementCostRequest {
    return {
      agreementId: isSet(object.agreementId) ? globalThis.Number(object.agreementId) : 0,
      amount: isSet(object.amount) ? globalThis.Number(object.amount) : 0,
      currency: isSet(object.currency) ? globalThis.String(object.currency) : "",
      notes: isSet(object.notes) ? globalThis.String(object.notes) : "",
      month: isSet(object.month) ? globalThis.String(object.month) : "",
    };
  },

  toJSON(message: CreateAgreementCostRequest): unknown {
    const obj: any = {};
    if (message.agreementId !== 0) {
      obj.agreementId = Math.round(message.agreementId);
    }
    if (message.amount !== 0) {
      obj.amount = Math.round(message.amount);
    }
    if (message.currency !== "") {
      obj.currency = message.currency;
    }
    if (message.notes !== "") {
      obj.notes = message.notes;
    }
    if (message.month !== "") {
      obj.month = message.month;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateAgreementCostRequest>, I>>(base?: I): CreateAgreementCostRequest {
    return CreateAgreementCostRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateAgreementCostRequest>, I>>(object: I): CreateAgreementCostRequest {
    const message = createBaseCreateAgreementCostRequest();
    message.agreementId = object.agreementId ?? 0;
    message.amount = object.amount ?? 0;
    message.currency = object.currency ?? "";
    message.notes = object.notes ?? "";
    message.month = object.month ?? "";
    return message;
  },
};

function createBaseCreateAgreementCostReply(): CreateAgreementCostReply {
  return {};
}

export const CreateAgreementCostReply = {
  encode(_: CreateAgreementCostReply, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CreateAgreementCostReply {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateAgreementCostReply();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): CreateAgreementCostReply {
    return {};
  },

  toJSON(_: CreateAgreementCostReply): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateAgreementCostReply>, I>>(base?: I): CreateAgreementCostReply {
    return CreateAgreementCostReply.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateAgreementCostReply>, I>>(_: I): CreateAgreementCostReply {
    const message = createBaseCreateAgreementCostReply();
    return message;
  },
};

function createBaseEditAgreementCostRequest(): EditAgreementCostRequest {
  return { agreementId: 0, costId: 0, amount: 0, currency: "", notes: "", month: "" };
}

export const EditAgreementCostRequest = {
  encode(message: EditAgreementCostRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.agreementId !== 0) {
      writer.uint32(8).int32(message.agreementId);
    }
    if (message.costId !== 0) {
      writer.uint32(16).int32(message.costId);
    }
    if (message.amount !== 0) {
      writer.uint32(24).int32(message.amount);
    }
    if (message.currency !== "") {
      writer.uint32(34).string(message.currency);
    }
    if (message.notes !== "") {
      writer.uint32(42).string(message.notes);
    }
    if (message.month !== "") {
      writer.uint32(50).string(message.month);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): EditAgreementCostRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEditAgreementCostRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.agreementId = reader.int32();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.costId = reader.int32();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.amount = reader.int32();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.currency = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.notes = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.month = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EditAgreementCostRequest {
    return {
      agreementId: isSet(object.agreementId) ? globalThis.Number(object.agreementId) : 0,
      costId: isSet(object.costId) ? globalThis.Number(object.costId) : 0,
      amount: isSet(object.amount) ? globalThis.Number(object.amount) : 0,
      currency: isSet(object.currency) ? globalThis.String(object.currency) : "",
      notes: isSet(object.notes) ? globalThis.String(object.notes) : "",
      month: isSet(object.month) ? globalThis.String(object.month) : "",
    };
  },

  toJSON(message: EditAgreementCostRequest): unknown {
    const obj: any = {};
    if (message.agreementId !== 0) {
      obj.agreementId = Math.round(message.agreementId);
    }
    if (message.costId !== 0) {
      obj.costId = Math.round(message.costId);
    }
    if (message.amount !== 0) {
      obj.amount = Math.round(message.amount);
    }
    if (message.currency !== "") {
      obj.currency = message.currency;
    }
    if (message.notes !== "") {
      obj.notes = message.notes;
    }
    if (message.month !== "") {
      obj.month = message.month;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EditAgreementCostRequest>, I>>(base?: I): EditAgreementCostRequest {
    return EditAgreementCostRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EditAgreementCostRequest>, I>>(object: I): EditAgreementCostRequest {
    const message = createBaseEditAgreementCostRequest();
    message.agreementId = object.agreementId ?? 0;
    message.costId = object.costId ?? 0;
    message.amount = object.amount ?? 0;
    message.currency = object.currency ?? "";
    message.notes = object.notes ?? "";
    message.month = object.month ?? "";
    return message;
  },
};

function createBaseEditAgreementCostReply(): EditAgreementCostReply {
  return {};
}

export const EditAgreementCostReply = {
  encode(_: EditAgreementCostReply, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): EditAgreementCostReply {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEditAgreementCostReply();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): EditAgreementCostReply {
    return {};
  },

  toJSON(_: EditAgreementCostReply): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<EditAgreementCostReply>, I>>(base?: I): EditAgreementCostReply {
    return EditAgreementCostReply.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EditAgreementCostReply>, I>>(_: I): EditAgreementCostReply {
    const message = createBaseEditAgreementCostReply();
    return message;
  },
};

function createBaseAgreementCostInfoRequest(): AgreementCostInfoRequest {
  return { costId: 0 };
}

export const AgreementCostInfoRequest = {
  encode(message: AgreementCostInfoRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.costId !== 0) {
      writer.uint32(8).int32(message.costId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AgreementCostInfoRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAgreementCostInfoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.costId = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AgreementCostInfoRequest {
    return { costId: isSet(object.costId) ? globalThis.Number(object.costId) : 0 };
  },

  toJSON(message: AgreementCostInfoRequest): unknown {
    const obj: any = {};
    if (message.costId !== 0) {
      obj.costId = Math.round(message.costId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AgreementCostInfoRequest>, I>>(base?: I): AgreementCostInfoRequest {
    return AgreementCostInfoRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AgreementCostInfoRequest>, I>>(object: I): AgreementCostInfoRequest {
    const message = createBaseAgreementCostInfoRequest();
    message.costId = object.costId ?? 0;
    return message;
  },
};

function createBaseAgreementCostInfoReply(): AgreementCostInfoReply {
  return { agreementId: 0, costId: 0, amount: 0, currency: "", notes: "", month: "" };
}

export const AgreementCostInfoReply = {
  encode(message: AgreementCostInfoReply, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.agreementId !== 0) {
      writer.uint32(8).int32(message.agreementId);
    }
    if (message.costId !== 0) {
      writer.uint32(16).int32(message.costId);
    }
    if (message.amount !== 0) {
      writer.uint32(24).int32(message.amount);
    }
    if (message.currency !== "") {
      writer.uint32(34).string(message.currency);
    }
    if (message.notes !== "") {
      writer.uint32(42).string(message.notes);
    }
    if (message.month !== "") {
      writer.uint32(50).string(message.month);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AgreementCostInfoReply {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAgreementCostInfoReply();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.agreementId = reader.int32();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.costId = reader.int32();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.amount = reader.int32();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.currency = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.notes = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.month = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AgreementCostInfoReply {
    return {
      agreementId: isSet(object.agreementId) ? globalThis.Number(object.agreementId) : 0,
      costId: isSet(object.costId) ? globalThis.Number(object.costId) : 0,
      amount: isSet(object.amount) ? globalThis.Number(object.amount) : 0,
      currency: isSet(object.currency) ? globalThis.String(object.currency) : "",
      notes: isSet(object.notes) ? globalThis.String(object.notes) : "",
      month: isSet(object.month) ? globalThis.String(object.month) : "",
    };
  },

  toJSON(message: AgreementCostInfoReply): unknown {
    const obj: any = {};
    if (message.agreementId !== 0) {
      obj.agreementId = Math.round(message.agreementId);
    }
    if (message.costId !== 0) {
      obj.costId = Math.round(message.costId);
    }
    if (message.amount !== 0) {
      obj.amount = Math.round(message.amount);
    }
    if (message.currency !== "") {
      obj.currency = message.currency;
    }
    if (message.notes !== "") {
      obj.notes = message.notes;
    }
    if (message.month !== "") {
      obj.month = message.month;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AgreementCostInfoReply>, I>>(base?: I): AgreementCostInfoReply {
    return AgreementCostInfoReply.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AgreementCostInfoReply>, I>>(object: I): AgreementCostInfoReply {
    const message = createBaseAgreementCostInfoReply();
    message.agreementId = object.agreementId ?? 0;
    message.costId = object.costId ?? 0;
    message.amount = object.amount ?? 0;
    message.currency = object.currency ?? "";
    message.notes = object.notes ?? "";
    message.month = object.month ?? "";
    return message;
  },
};

function createBaseDeleteAgreementCostRequest(): DeleteAgreementCostRequest {
  return { costId: 0 };
}

export const DeleteAgreementCostRequest = {
  encode(message: DeleteAgreementCostRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.costId !== 0) {
      writer.uint32(8).int32(message.costId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DeleteAgreementCostRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteAgreementCostRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.costId = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteAgreementCostRequest {
    return { costId: isSet(object.costId) ? globalThis.Number(object.costId) : 0 };
  },

  toJSON(message: DeleteAgreementCostRequest): unknown {
    const obj: any = {};
    if (message.costId !== 0) {
      obj.costId = Math.round(message.costId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteAgreementCostRequest>, I>>(base?: I): DeleteAgreementCostRequest {
    return DeleteAgreementCostRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteAgreementCostRequest>, I>>(object: I): DeleteAgreementCostRequest {
    const message = createBaseDeleteAgreementCostRequest();
    message.costId = object.costId ?? 0;
    return message;
  },
};

function createBaseDeleteAgreementCostReply(): DeleteAgreementCostReply {
  return {};
}

export const DeleteAgreementCostReply = {
  encode(_: DeleteAgreementCostReply, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DeleteAgreementCostReply {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteAgreementCostReply();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): DeleteAgreementCostReply {
    return {};
  },

  toJSON(_: DeleteAgreementCostReply): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteAgreementCostReply>, I>>(base?: I): DeleteAgreementCostReply {
    return DeleteAgreementCostReply.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteAgreementCostReply>, I>>(_: I): DeleteAgreementCostReply {
    const message = createBaseDeleteAgreementCostReply();
    return message;
  },
};

function createBaseCostSummaryRequest(): CostSummaryRequest {
  return { period: "", startDate: "", endDate: "", includeNode: false, namespace: "", kind: "", type: "", labels: "" };
}

export const CostSummaryRequest = {
  encode(message: CostSummaryRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.period !== "") {
      writer.uint32(10).string(message.period);
    }
    if (message.startDate !== "") {
      writer.uint32(18).string(message.startDate);
    }
    if (message.endDate !== "") {
      writer.uint32(26).string(message.endDate);
    }
    if (message.includeNode !== false) {
      writer.uint32(32).bool(message.includeNode);
    }
    if (message.namespace !== "") {
      writer.uint32(42).string(message.namespace);
    }
    if (message.kind !== "") {
      writer.uint32(50).string(message.kind);
    }
    if (message.type !== "") {
      writer.uint32(58).string(message.type);
    }
    if (message.labels !== "") {
      writer.uint32(66).string(message.labels);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CostSummaryRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCostSummaryRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.period = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.startDate = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.endDate = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.includeNode = reader.bool();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.namespace = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.kind = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.type = reader.string();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.labels = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CostSummaryRequest {
    return {
      period: isSet(object.period) ? globalThis.String(object.period) : "",
      startDate: isSet(object.startDate) ? globalThis.String(object.startDate) : "",
      endDate: isSet(object.endDate) ? globalThis.String(object.endDate) : "",
      includeNode: isSet(object.includeNode) ? globalThis.Boolean(object.includeNode) : false,
      namespace: isSet(object.namespace) ? globalThis.String(object.namespace) : "",
      kind: isSet(object.kind) ? globalThis.String(object.kind) : "",
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      labels: isSet(object.labels) ? globalThis.String(object.labels) : "",
    };
  },

  toJSON(message: CostSummaryRequest): unknown {
    const obj: any = {};
    if (message.period !== "") {
      obj.period = message.period;
    }
    if (message.startDate !== "") {
      obj.startDate = message.startDate;
    }
    if (message.endDate !== "") {
      obj.endDate = message.endDate;
    }
    if (message.includeNode !== false) {
      obj.includeNode = message.includeNode;
    }
    if (message.namespace !== "") {
      obj.namespace = message.namespace;
    }
    if (message.kind !== "") {
      obj.kind = message.kind;
    }
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.labels !== "") {
      obj.labels = message.labels;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CostSummaryRequest>, I>>(base?: I): CostSummaryRequest {
    return CostSummaryRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CostSummaryRequest>, I>>(object: I): CostSummaryRequest {
    const message = createBaseCostSummaryRequest();
    message.period = object.period ?? "";
    message.startDate = object.startDate ?? "";
    message.endDate = object.endDate ?? "";
    message.includeNode = object.includeNode ?? false;
    message.namespace = object.namespace ?? "";
    message.kind = object.kind ?? "";
    message.type = object.type ?? "";
    message.labels = object.labels ?? "";
    return message;
  },
};

function createBaseCostSummaryReply(): CostSummaryReply {
  return { period: "", items: [] };
}

export const CostSummaryReply = {
  encode(message: CostSummaryReply, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.period !== "") {
      writer.uint32(10).string(message.period);
    }
    for (const v of message.items) {
      CostSummaryItem.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CostSummaryReply {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCostSummaryReply();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.period = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.items.push(CostSummaryItem.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CostSummaryReply {
    return {
      period: isSet(object.period) ? globalThis.String(object.period) : "",
      items: globalThis.Array.isArray(object?.items) ? object.items.map((e: any) => CostSummaryItem.fromJSON(e)) : [],
    };
  },

  toJSON(message: CostSummaryReply): unknown {
    const obj: any = {};
    if (message.period !== "") {
      obj.period = message.period;
    }
    if (message.items?.length) {
      obj.items = message.items.map((e) => CostSummaryItem.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CostSummaryReply>, I>>(base?: I): CostSummaryReply {
    return CostSummaryReply.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CostSummaryReply>, I>>(object: I): CostSummaryReply {
    const message = createBaseCostSummaryReply();
    message.period = object.period ?? "";
    message.items = object.items?.map((e) => CostSummaryItem.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCostSummaryItem(): CostSummaryItem {
  return { periodStart: "", periodEnd: "", totalCost: 0, details: undefined };
}

export const CostSummaryItem = {
  encode(message: CostSummaryItem, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.periodStart !== "") {
      writer.uint32(10).string(message.periodStart);
    }
    if (message.periodEnd !== "") {
      writer.uint32(18).string(message.periodEnd);
    }
    if (message.totalCost !== 0) {
      writer.uint32(25).double(message.totalCost);
    }
    if (message.details !== undefined) {
      CostSummaryDetails.encode(message.details, writer.uint32(34).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CostSummaryItem {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCostSummaryItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.periodStart = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.periodEnd = reader.string();
          continue;
        case 3:
          if (tag !== 25) {
            break;
          }

          message.totalCost = reader.double();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.details = CostSummaryDetails.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CostSummaryItem {
    return {
      periodStart: isSet(object.periodStart) ? globalThis.String(object.periodStart) : "",
      periodEnd: isSet(object.periodEnd) ? globalThis.String(object.periodEnd) : "",
      totalCost: isSet(object.totalCost) ? globalThis.Number(object.totalCost) : 0,
      details: isSet(object.details) ? CostSummaryDetails.fromJSON(object.details) : undefined,
    };
  },

  toJSON(message: CostSummaryItem): unknown {
    const obj: any = {};
    if (message.periodStart !== "") {
      obj.periodStart = message.periodStart;
    }
    if (message.periodEnd !== "") {
      obj.periodEnd = message.periodEnd;
    }
    if (message.totalCost !== 0) {
      obj.totalCost = message.totalCost;
    }
    if (message.details !== undefined) {
      obj.details = CostSummaryDetails.toJSON(message.details);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CostSummaryItem>, I>>(base?: I): CostSummaryItem {
    return CostSummaryItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CostSummaryItem>, I>>(object: I): CostSummaryItem {
    const message = createBaseCostSummaryItem();
    message.periodStart = object.periodStart ?? "";
    message.periodEnd = object.periodEnd ?? "";
    message.totalCost = object.totalCost ?? 0;
    message.details = (object.details !== undefined && object.details !== null)
      ? CostSummaryDetails.fromPartial(object.details)
      : undefined;
    return message;
  },
};

function createBaseCostSummaryDetails(): CostSummaryDetails {
  return { compute: 0, storage: 0, network: 0 };
}

export const CostSummaryDetails = {
  encode(message: CostSummaryDetails, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.compute !== 0) {
      writer.uint32(9).double(message.compute);
    }
    if (message.storage !== 0) {
      writer.uint32(17).double(message.storage);
    }
    if (message.network !== 0) {
      writer.uint32(25).double(message.network);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CostSummaryDetails {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCostSummaryDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 9) {
            break;
          }

          message.compute = reader.double();
          continue;
        case 2:
          if (tag !== 17) {
            break;
          }

          message.storage = reader.double();
          continue;
        case 3:
          if (tag !== 25) {
            break;
          }

          message.network = reader.double();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CostSummaryDetails {
    return {
      compute: isSet(object.compute) ? globalThis.Number(object.compute) : 0,
      storage: isSet(object.storage) ? globalThis.Number(object.storage) : 0,
      network: isSet(object.network) ? globalThis.Number(object.network) : 0,
    };
  },

  toJSON(message: CostSummaryDetails): unknown {
    const obj: any = {};
    if (message.compute !== 0) {
      obj.compute = message.compute;
    }
    if (message.storage !== 0) {
      obj.storage = message.storage;
    }
    if (message.network !== 0) {
      obj.network = message.network;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CostSummaryDetails>, I>>(base?: I): CostSummaryDetails {
    return CostSummaryDetails.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CostSummaryDetails>, I>>(object: I): CostSummaryDetails {
    const message = createBaseCostSummaryDetails();
    message.compute = object.compute ?? 0;
    message.storage = object.storage ?? 0;
    message.network = object.network ?? 0;
    return message;
  },
};

function createBaseCostSummaryV2Request(): CostSummaryV2Request {
  return { period: "", startDate: "", endDate: "", area: "", namespace: "", kind: "", type: "" };
}

export const CostSummaryV2Request = {
  encode(message: CostSummaryV2Request, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.period !== "") {
      writer.uint32(10).string(message.period);
    }
    if (message.startDate !== "") {
      writer.uint32(18).string(message.startDate);
    }
    if (message.endDate !== "") {
      writer.uint32(26).string(message.endDate);
    }
    if (message.area !== "") {
      writer.uint32(34).string(message.area);
    }
    if (message.namespace !== "") {
      writer.uint32(42).string(message.namespace);
    }
    if (message.kind !== "") {
      writer.uint32(50).string(message.kind);
    }
    if (message.type !== "") {
      writer.uint32(58).string(message.type);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CostSummaryV2Request {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCostSummaryV2Request();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.period = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.startDate = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.endDate = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.area = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.namespace = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.kind = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.type = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CostSummaryV2Request {
    return {
      period: isSet(object.period) ? globalThis.String(object.period) : "",
      startDate: isSet(object.startDate) ? globalThis.String(object.startDate) : "",
      endDate: isSet(object.endDate) ? globalThis.String(object.endDate) : "",
      area: isSet(object.area) ? globalThis.String(object.area) : "",
      namespace: isSet(object.namespace) ? globalThis.String(object.namespace) : "",
      kind: isSet(object.kind) ? globalThis.String(object.kind) : "",
      type: isSet(object.type) ? globalThis.String(object.type) : "",
    };
  },

  toJSON(message: CostSummaryV2Request): unknown {
    const obj: any = {};
    if (message.period !== "") {
      obj.period = message.period;
    }
    if (message.startDate !== "") {
      obj.startDate = message.startDate;
    }
    if (message.endDate !== "") {
      obj.endDate = message.endDate;
    }
    if (message.area !== "") {
      obj.area = message.area;
    }
    if (message.namespace !== "") {
      obj.namespace = message.namespace;
    }
    if (message.kind !== "") {
      obj.kind = message.kind;
    }
    if (message.type !== "") {
      obj.type = message.type;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CostSummaryV2Request>, I>>(base?: I): CostSummaryV2Request {
    return CostSummaryV2Request.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CostSummaryV2Request>, I>>(object: I): CostSummaryV2Request {
    const message = createBaseCostSummaryV2Request();
    message.period = object.period ?? "";
    message.startDate = object.startDate ?? "";
    message.endDate = object.endDate ?? "";
    message.area = object.area ?? "";
    message.namespace = object.namespace ?? "";
    message.kind = object.kind ?? "";
    message.type = object.type ?? "";
    return message;
  },
};

function createBaseCostSummaryV2Reply(): CostSummaryV2Reply {
  return { period: "", items: [] };
}

export const CostSummaryV2Reply = {
  encode(message: CostSummaryV2Reply, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.period !== "") {
      writer.uint32(10).string(message.period);
    }
    for (const v of message.items) {
      CostSummaryItemV2.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CostSummaryV2Reply {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCostSummaryV2Reply();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.period = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.items.push(CostSummaryItemV2.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CostSummaryV2Reply {
    return {
      period: isSet(object.period) ? globalThis.String(object.period) : "",
      items: globalThis.Array.isArray(object?.items) ? object.items.map((e: any) => CostSummaryItemV2.fromJSON(e)) : [],
    };
  },

  toJSON(message: CostSummaryV2Reply): unknown {
    const obj: any = {};
    if (message.period !== "") {
      obj.period = message.period;
    }
    if (message.items?.length) {
      obj.items = message.items.map((e) => CostSummaryItemV2.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CostSummaryV2Reply>, I>>(base?: I): CostSummaryV2Reply {
    return CostSummaryV2Reply.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CostSummaryV2Reply>, I>>(object: I): CostSummaryV2Reply {
    const message = createBaseCostSummaryV2Reply();
    message.period = object.period ?? "";
    message.items = object.items?.map((e) => CostSummaryItemV2.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCostSummaryItemV2(): CostSummaryItemV2 {
  return { periodStart: "", periodEnd: "", totalCost: 0, details: undefined };
}

export const CostSummaryItemV2 = {
  encode(message: CostSummaryItemV2, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.periodStart !== "") {
      writer.uint32(10).string(message.periodStart);
    }
    if (message.periodEnd !== "") {
      writer.uint32(18).string(message.periodEnd);
    }
    if (message.totalCost !== 0) {
      writer.uint32(25).double(message.totalCost);
    }
    if (message.details !== undefined) {
      CostSummaryDetailV2.encode(message.details, writer.uint32(34).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CostSummaryItemV2 {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCostSummaryItemV2();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.periodStart = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.periodEnd = reader.string();
          continue;
        case 3:
          if (tag !== 25) {
            break;
          }

          message.totalCost = reader.double();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.details = CostSummaryDetailV2.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CostSummaryItemV2 {
    return {
      periodStart: isSet(object.periodStart) ? globalThis.String(object.periodStart) : "",
      periodEnd: isSet(object.periodEnd) ? globalThis.String(object.periodEnd) : "",
      totalCost: isSet(object.totalCost) ? globalThis.Number(object.totalCost) : 0,
      details: isSet(object.details) ? CostSummaryDetailV2.fromJSON(object.details) : undefined,
    };
  },

  toJSON(message: CostSummaryItemV2): unknown {
    const obj: any = {};
    if (message.periodStart !== "") {
      obj.periodStart = message.periodStart;
    }
    if (message.periodEnd !== "") {
      obj.periodEnd = message.periodEnd;
    }
    if (message.totalCost !== 0) {
      obj.totalCost = message.totalCost;
    }
    if (message.details !== undefined) {
      obj.details = CostSummaryDetailV2.toJSON(message.details);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CostSummaryItemV2>, I>>(base?: I): CostSummaryItemV2 {
    return CostSummaryItemV2.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CostSummaryItemV2>, I>>(object: I): CostSummaryItemV2 {
    const message = createBaseCostSummaryItemV2();
    message.periodStart = object.periodStart ?? "";
    message.periodEnd = object.periodEnd ?? "";
    message.totalCost = object.totalCost ?? 0;
    message.details = (object.details !== undefined && object.details !== null)
      ? CostSummaryDetailV2.fromPartial(object.details)
      : undefined;
    return message;
  },
};

function createBaseCostSummaryDetailV2(): CostSummaryDetailV2 {
  return { compute: 0, storage: 0, network: 0 };
}

export const CostSummaryDetailV2 = {
  encode(message: CostSummaryDetailV2, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.compute !== 0) {
      writer.uint32(9).double(message.compute);
    }
    if (message.storage !== 0) {
      writer.uint32(17).double(message.storage);
    }
    if (message.network !== 0) {
      writer.uint32(25).double(message.network);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CostSummaryDetailV2 {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCostSummaryDetailV2();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 9) {
            break;
          }

          message.compute = reader.double();
          continue;
        case 2:
          if (tag !== 17) {
            break;
          }

          message.storage = reader.double();
          continue;
        case 3:
          if (tag !== 25) {
            break;
          }

          message.network = reader.double();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CostSummaryDetailV2 {
    return {
      compute: isSet(object.compute) ? globalThis.Number(object.compute) : 0,
      storage: isSet(object.storage) ? globalThis.Number(object.storage) : 0,
      network: isSet(object.network) ? globalThis.Number(object.network) : 0,
    };
  },

  toJSON(message: CostSummaryDetailV2): unknown {
    const obj: any = {};
    if (message.compute !== 0) {
      obj.compute = message.compute;
    }
    if (message.storage !== 0) {
      obj.storage = message.storage;
    }
    if (message.network !== 0) {
      obj.network = message.network;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CostSummaryDetailV2>, I>>(base?: I): CostSummaryDetailV2 {
    return CostSummaryDetailV2.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CostSummaryDetailV2>, I>>(object: I): CostSummaryDetailV2 {
    const message = createBaseCostSummaryDetailV2();
    message.compute = object.compute ?? 0;
    message.storage = object.storage ?? 0;
    message.network = object.network ?? 0;
    return message;
  },
};

function createBaseResourceNamespaceListRequest(): ResourceNamespaceListRequest {
  return { type: "" };
}

export const ResourceNamespaceListRequest = {
  encode(message: ResourceNamespaceListRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.type !== "") {
      writer.uint32(10).string(message.type);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ResourceNamespaceListRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResourceNamespaceListRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.type = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ResourceNamespaceListRequest {
    return { type: isSet(object.type) ? globalThis.String(object.type) : "" };
  },

  toJSON(message: ResourceNamespaceListRequest): unknown {
    const obj: any = {};
    if (message.type !== "") {
      obj.type = message.type;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ResourceNamespaceListRequest>, I>>(base?: I): ResourceNamespaceListRequest {
    return ResourceNamespaceListRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ResourceNamespaceListRequest>, I>>(object: I): ResourceNamespaceListRequest {
    const message = createBaseResourceNamespaceListRequest();
    message.type = object.type ?? "";
    return message;
  },
};

function createBaseResourceNamespaceListReply(): ResourceNamespaceListReply {
  return { namespace: [] };
}

export const ResourceNamespaceListReply = {
  encode(message: ResourceNamespaceListReply, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.namespace) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ResourceNamespaceListReply {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResourceNamespaceListReply();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.namespace.push(reader.string());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ResourceNamespaceListReply {
    return {
      namespace: globalThis.Array.isArray(object?.namespace)
        ? object.namespace.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: ResourceNamespaceListReply): unknown {
    const obj: any = {};
    if (message.namespace?.length) {
      obj.namespace = message.namespace;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ResourceNamespaceListReply>, I>>(base?: I): ResourceNamespaceListReply {
    return ResourceNamespaceListReply.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ResourceNamespaceListReply>, I>>(object: I): ResourceNamespaceListReply {
    const message = createBaseResourceNamespaceListReply();
    message.namespace = object.namespace?.map((e) => e) || [];
    return message;
  },
};

function createBaseBusinessCostSummaryRequest(): BusinessCostSummaryRequest {
  return {
    namespace: "",
    startTime: "",
    endTime: "",
    business: "",
    kind: "",
    type: "",
    subResource: "",
    interval: "",
    area: 0,
  };
}

export const BusinessCostSummaryRequest = {
  encode(message: BusinessCostSummaryRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.namespace !== "") {
      writer.uint32(10).string(message.namespace);
    }
    if (message.startTime !== "") {
      writer.uint32(18).string(message.startTime);
    }
    if (message.endTime !== "") {
      writer.uint32(26).string(message.endTime);
    }
    if (message.business !== "") {
      writer.uint32(34).string(message.business);
    }
    if (message.kind !== "") {
      writer.uint32(42).string(message.kind);
    }
    if (message.type !== "") {
      writer.uint32(50).string(message.type);
    }
    if (message.subResource !== "") {
      writer.uint32(58).string(message.subResource);
    }
    if (message.interval !== "") {
      writer.uint32(66).string(message.interval);
    }
    if (message.area !== 0) {
      writer.uint32(72).int32(message.area);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): BusinessCostSummaryRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBusinessCostSummaryRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.namespace = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.startTime = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.endTime = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.business = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.kind = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.type = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.subResource = reader.string();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.interval = reader.string();
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.area = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BusinessCostSummaryRequest {
    return {
      namespace: isSet(object.namespace) ? globalThis.String(object.namespace) : "",
      startTime: isSet(object.startTime) ? globalThis.String(object.startTime) : "",
      endTime: isSet(object.endTime) ? globalThis.String(object.endTime) : "",
      business: isSet(object.business) ? globalThis.String(object.business) : "",
      kind: isSet(object.kind) ? globalThis.String(object.kind) : "",
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      subResource: isSet(object.subResource) ? globalThis.String(object.subResource) : "",
      interval: isSet(object.interval) ? globalThis.String(object.interval) : "",
      area: isSet(object.area) ? areaTypeFromJSON(object.area) : 0,
    };
  },

  toJSON(message: BusinessCostSummaryRequest): unknown {
    const obj: any = {};
    if (message.namespace !== "") {
      obj.namespace = message.namespace;
    }
    if (message.startTime !== "") {
      obj.startTime = message.startTime;
    }
    if (message.endTime !== "") {
      obj.endTime = message.endTime;
    }
    if (message.business !== "") {
      obj.business = message.business;
    }
    if (message.kind !== "") {
      obj.kind = message.kind;
    }
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.subResource !== "") {
      obj.subResource = message.subResource;
    }
    if (message.interval !== "") {
      obj.interval = message.interval;
    }
    if (message.area !== 0) {
      obj.area = areaTypeToJSON(message.area);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BusinessCostSummaryRequest>, I>>(base?: I): BusinessCostSummaryRequest {
    return BusinessCostSummaryRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BusinessCostSummaryRequest>, I>>(object: I): BusinessCostSummaryRequest {
    const message = createBaseBusinessCostSummaryRequest();
    message.namespace = object.namespace ?? "";
    message.startTime = object.startTime ?? "";
    message.endTime = object.endTime ?? "";
    message.business = object.business ?? "";
    message.kind = object.kind ?? "";
    message.type = object.type ?? "";
    message.subResource = object.subResource ?? "";
    message.interval = object.interval ?? "";
    message.area = object.area ?? 0;
    return message;
  },
};

function createBaseBusinessCostSummaryReply(): BusinessCostSummaryReply {
  return { items: [] };
}

export const BusinessCostSummaryReply = {
  encode(message: BusinessCostSummaryReply, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.items) {
      BusinessCostRecord.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): BusinessCostSummaryReply {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBusinessCostSummaryReply();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.items.push(BusinessCostRecord.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BusinessCostSummaryReply {
    return {
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => BusinessCostRecord.fromJSON(e))
        : [],
    };
  },

  toJSON(message: BusinessCostSummaryReply): unknown {
    const obj: any = {};
    if (message.items?.length) {
      obj.items = message.items.map((e) => BusinessCostRecord.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BusinessCostSummaryReply>, I>>(base?: I): BusinessCostSummaryReply {
    return BusinessCostSummaryReply.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BusinessCostSummaryReply>, I>>(object: I): BusinessCostSummaryReply {
    const message = createBaseBusinessCostSummaryReply();
    message.items = object.items?.map((e) => BusinessCostRecord.fromPartial(e)) || [];
    return message;
  },
};

function createBaseBusinessCostRecord(): BusinessCostRecord {
  return {
    id: 0,
    billingUnitId: 0,
    valueCounter: 0,
    startTime: "",
    endTime: "",
    interval: "",
    costCounter: 0,
    name: "",
    business: "",
    kind: "",
    type: "",
    subResource: "",
    k8sAppName: "",
  };
}

export const BusinessCostRecord = {
  encode(message: BusinessCostRecord, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== 0) {
      writer.uint32(8).int64(message.id);
    }
    if (message.billingUnitId !== 0) {
      writer.uint32(16).int64(message.billingUnitId);
    }
    if (message.valueCounter !== 0) {
      writer.uint32(25).double(message.valueCounter);
    }
    if (message.startTime !== "") {
      writer.uint32(34).string(message.startTime);
    }
    if (message.endTime !== "") {
      writer.uint32(42).string(message.endTime);
    }
    if (message.interval !== "") {
      writer.uint32(50).string(message.interval);
    }
    if (message.costCounter !== 0) {
      writer.uint32(57).double(message.costCounter);
    }
    if (message.name !== "") {
      writer.uint32(66).string(message.name);
    }
    if (message.business !== "") {
      writer.uint32(74).string(message.business);
    }
    if (message.kind !== "") {
      writer.uint32(82).string(message.kind);
    }
    if (message.type !== "") {
      writer.uint32(90).string(message.type);
    }
    if (message.subResource !== "") {
      writer.uint32(98).string(message.subResource);
    }
    if (message.k8sAppName !== "") {
      writer.uint32(106).string(message.k8sAppName);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): BusinessCostRecord {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBusinessCostRecord();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.billingUnitId = longToNumber(reader.int64() as Long);
          continue;
        case 3:
          if (tag !== 25) {
            break;
          }

          message.valueCounter = reader.double();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.startTime = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.endTime = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.interval = reader.string();
          continue;
        case 7:
          if (tag !== 57) {
            break;
          }

          message.costCounter = reader.double();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.name = reader.string();
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.business = reader.string();
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.kind = reader.string();
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.type = reader.string();
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.subResource = reader.string();
          continue;
        case 13:
          if (tag !== 106) {
            break;
          }

          message.k8sAppName = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BusinessCostRecord {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      billingUnitId: isSet(object.billingUnitId) ? globalThis.Number(object.billingUnitId) : 0,
      valueCounter: isSet(object.valueCounter) ? globalThis.Number(object.valueCounter) : 0,
      startTime: isSet(object.startTime) ? globalThis.String(object.startTime) : "",
      endTime: isSet(object.endTime) ? globalThis.String(object.endTime) : "",
      interval: isSet(object.interval) ? globalThis.String(object.interval) : "",
      costCounter: isSet(object.costCounter) ? globalThis.Number(object.costCounter) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      business: isSet(object.business) ? globalThis.String(object.business) : "",
      kind: isSet(object.kind) ? globalThis.String(object.kind) : "",
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      subResource: isSet(object.subResource) ? globalThis.String(object.subResource) : "",
      k8sAppName: isSet(object.k8sAppName) ? globalThis.String(object.k8sAppName) : "",
    };
  },

  toJSON(message: BusinessCostRecord): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.billingUnitId !== 0) {
      obj.billingUnitId = Math.round(message.billingUnitId);
    }
    if (message.valueCounter !== 0) {
      obj.valueCounter = message.valueCounter;
    }
    if (message.startTime !== "") {
      obj.startTime = message.startTime;
    }
    if (message.endTime !== "") {
      obj.endTime = message.endTime;
    }
    if (message.interval !== "") {
      obj.interval = message.interval;
    }
    if (message.costCounter !== 0) {
      obj.costCounter = message.costCounter;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.business !== "") {
      obj.business = message.business;
    }
    if (message.kind !== "") {
      obj.kind = message.kind;
    }
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.subResource !== "") {
      obj.subResource = message.subResource;
    }
    if (message.k8sAppName !== "") {
      obj.k8sAppName = message.k8sAppName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BusinessCostRecord>, I>>(base?: I): BusinessCostRecord {
    return BusinessCostRecord.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BusinessCostRecord>, I>>(object: I): BusinessCostRecord {
    const message = createBaseBusinessCostRecord();
    message.id = object.id ?? 0;
    message.billingUnitId = object.billingUnitId ?? 0;
    message.valueCounter = object.valueCounter ?? 0;
    message.startTime = object.startTime ?? "";
    message.endTime = object.endTime ?? "";
    message.interval = object.interval ?? "";
    message.costCounter = object.costCounter ?? 0;
    message.name = object.name ?? "";
    message.business = object.business ?? "";
    message.kind = object.kind ?? "";
    message.type = object.type ?? "";
    message.subResource = object.subResource ?? "";
    message.k8sAppName = object.k8sAppName ?? "";
    return message;
  },
};

function createBasePeriodicCostRecordsRequest(): PeriodicCostRecordsRequest {
  return {
    startTime: "",
    endTime: "",
    namespace: "",
    kind: "",
    type: "",
    subresource: "",
    billingUnitId: 0,
    resourceName: "",
    nameRegex: "",
    labels: "",
    interval: "",
    page: 0,
    pageSize: 0,
  };
}

export const PeriodicCostRecordsRequest = {
  encode(message: PeriodicCostRecordsRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.startTime !== "") {
      writer.uint32(10).string(message.startTime);
    }
    if (message.endTime !== "") {
      writer.uint32(18).string(message.endTime);
    }
    if (message.namespace !== "") {
      writer.uint32(26).string(message.namespace);
    }
    if (message.kind !== "") {
      writer.uint32(34).string(message.kind);
    }
    if (message.type !== "") {
      writer.uint32(42).string(message.type);
    }
    if (message.subresource !== "") {
      writer.uint32(50).string(message.subresource);
    }
    if (message.billingUnitId !== 0) {
      writer.uint32(56).int64(message.billingUnitId);
    }
    if (message.resourceName !== "") {
      writer.uint32(66).string(message.resourceName);
    }
    if (message.nameRegex !== "") {
      writer.uint32(74).string(message.nameRegex);
    }
    if (message.labels !== "") {
      writer.uint32(82).string(message.labels);
    }
    if (message.interval !== "") {
      writer.uint32(90).string(message.interval);
    }
    if (message.page !== 0) {
      writer.uint32(96).int32(message.page);
    }
    if (message.pageSize !== 0) {
      writer.uint32(104).int32(message.pageSize);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PeriodicCostRecordsRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePeriodicCostRecordsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.startTime = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.endTime = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.namespace = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.kind = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.type = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.subresource = reader.string();
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.billingUnitId = longToNumber(reader.int64() as Long);
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.resourceName = reader.string();
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.nameRegex = reader.string();
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.labels = reader.string();
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.interval = reader.string();
          continue;
        case 12:
          if (tag !== 96) {
            break;
          }

          message.page = reader.int32();
          continue;
        case 13:
          if (tag !== 104) {
            break;
          }

          message.pageSize = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PeriodicCostRecordsRequest {
    return {
      startTime: isSet(object.startTime) ? globalThis.String(object.startTime) : "",
      endTime: isSet(object.endTime) ? globalThis.String(object.endTime) : "",
      namespace: isSet(object.namespace) ? globalThis.String(object.namespace) : "",
      kind: isSet(object.kind) ? globalThis.String(object.kind) : "",
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      subresource: isSet(object.subresource) ? globalThis.String(object.subresource) : "",
      billingUnitId: isSet(object.billingUnitId) ? globalThis.Number(object.billingUnitId) : 0,
      resourceName: isSet(object.resourceName) ? globalThis.String(object.resourceName) : "",
      nameRegex: isSet(object.nameRegex) ? globalThis.String(object.nameRegex) : "",
      labels: isSet(object.labels) ? globalThis.String(object.labels) : "",
      interval: isSet(object.interval) ? globalThis.String(object.interval) : "",
      page: isSet(object.page) ? globalThis.Number(object.page) : 0,
      pageSize: isSet(object.pageSize) ? globalThis.Number(object.pageSize) : 0,
    };
  },

  toJSON(message: PeriodicCostRecordsRequest): unknown {
    const obj: any = {};
    if (message.startTime !== "") {
      obj.startTime = message.startTime;
    }
    if (message.endTime !== "") {
      obj.endTime = message.endTime;
    }
    if (message.namespace !== "") {
      obj.namespace = message.namespace;
    }
    if (message.kind !== "") {
      obj.kind = message.kind;
    }
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.subresource !== "") {
      obj.subresource = message.subresource;
    }
    if (message.billingUnitId !== 0) {
      obj.billingUnitId = Math.round(message.billingUnitId);
    }
    if (message.resourceName !== "") {
      obj.resourceName = message.resourceName;
    }
    if (message.nameRegex !== "") {
      obj.nameRegex = message.nameRegex;
    }
    if (message.labels !== "") {
      obj.labels = message.labels;
    }
    if (message.interval !== "") {
      obj.interval = message.interval;
    }
    if (message.page !== 0) {
      obj.page = Math.round(message.page);
    }
    if (message.pageSize !== 0) {
      obj.pageSize = Math.round(message.pageSize);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PeriodicCostRecordsRequest>, I>>(base?: I): PeriodicCostRecordsRequest {
    return PeriodicCostRecordsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PeriodicCostRecordsRequest>, I>>(object: I): PeriodicCostRecordsRequest {
    const message = createBasePeriodicCostRecordsRequest();
    message.startTime = object.startTime ?? "";
    message.endTime = object.endTime ?? "";
    message.namespace = object.namespace ?? "";
    message.kind = object.kind ?? "";
    message.type = object.type ?? "";
    message.subresource = object.subresource ?? "";
    message.billingUnitId = object.billingUnitId ?? 0;
    message.resourceName = object.resourceName ?? "";
    message.nameRegex = object.nameRegex ?? "";
    message.labels = object.labels ?? "";
    message.interval = object.interval ?? "";
    message.page = object.page ?? 0;
    message.pageSize = object.pageSize ?? 0;
    return message;
  },
};

function createBasePeriodicCostRecordsReply(): PeriodicCostRecordsReply {
  return { items: [], meta: undefined };
}

export const PeriodicCostRecordsReply = {
  encode(message: PeriodicCostRecordsReply, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.items) {
      PeriodicCostRecord.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    if (message.meta !== undefined) {
      Meta.encode(message.meta, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PeriodicCostRecordsReply {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePeriodicCostRecordsReply();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.items.push(PeriodicCostRecord.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.meta = Meta.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PeriodicCostRecordsReply {
    return {
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => PeriodicCostRecord.fromJSON(e))
        : [],
      meta: isSet(object.meta) ? Meta.fromJSON(object.meta) : undefined,
    };
  },

  toJSON(message: PeriodicCostRecordsReply): unknown {
    const obj: any = {};
    if (message.items?.length) {
      obj.items = message.items.map((e) => PeriodicCostRecord.toJSON(e));
    }
    if (message.meta !== undefined) {
      obj.meta = Meta.toJSON(message.meta);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PeriodicCostRecordsReply>, I>>(base?: I): PeriodicCostRecordsReply {
    return PeriodicCostRecordsReply.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PeriodicCostRecordsReply>, I>>(object: I): PeriodicCostRecordsReply {
    const message = createBasePeriodicCostRecordsReply();
    message.items = object.items?.map((e) => PeriodicCostRecord.fromPartial(e)) || [];
    message.meta = (object.meta !== undefined && object.meta !== null) ? Meta.fromPartial(object.meta) : undefined;
    return message;
  },
};

function createBasePeriodicCostRecord(): PeriodicCostRecord {
  return {
    id: 0,
    billingUnitId: 0,
    billingUnit: undefined,
    startTime: "",
    endTime: "",
    interval: "",
    costCounter: 0,
    valueCounter: 0,
  };
}

export const PeriodicCostRecord = {
  encode(message: PeriodicCostRecord, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== 0) {
      writer.uint32(8).int64(message.id);
    }
    if (message.billingUnitId !== 0) {
      writer.uint32(16).int64(message.billingUnitId);
    }
    if (message.billingUnit !== undefined) {
      BillingUnit.encode(message.billingUnit, writer.uint32(26).fork()).ldelim();
    }
    if (message.startTime !== "") {
      writer.uint32(34).string(message.startTime);
    }
    if (message.endTime !== "") {
      writer.uint32(42).string(message.endTime);
    }
    if (message.interval !== "") {
      writer.uint32(50).string(message.interval);
    }
    if (message.costCounter !== 0) {
      writer.uint32(57).double(message.costCounter);
    }
    if (message.valueCounter !== 0) {
      writer.uint32(65).double(message.valueCounter);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PeriodicCostRecord {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePeriodicCostRecord();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.billingUnitId = longToNumber(reader.int64() as Long);
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.billingUnit = BillingUnit.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.startTime = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.endTime = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.interval = reader.string();
          continue;
        case 7:
          if (tag !== 57) {
            break;
          }

          message.costCounter = reader.double();
          continue;
        case 8:
          if (tag !== 65) {
            break;
          }

          message.valueCounter = reader.double();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PeriodicCostRecord {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      billingUnitId: isSet(object.billingUnitId) ? globalThis.Number(object.billingUnitId) : 0,
      billingUnit: isSet(object.billingUnit) ? BillingUnit.fromJSON(object.billingUnit) : undefined,
      startTime: isSet(object.startTime) ? globalThis.String(object.startTime) : "",
      endTime: isSet(object.endTime) ? globalThis.String(object.endTime) : "",
      interval: isSet(object.interval) ? globalThis.String(object.interval) : "",
      costCounter: isSet(object.costCounter) ? globalThis.Number(object.costCounter) : 0,
      valueCounter: isSet(object.valueCounter) ? globalThis.Number(object.valueCounter) : 0,
    };
  },

  toJSON(message: PeriodicCostRecord): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.billingUnitId !== 0) {
      obj.billingUnitId = Math.round(message.billingUnitId);
    }
    if (message.billingUnit !== undefined) {
      obj.billingUnit = BillingUnit.toJSON(message.billingUnit);
    }
    if (message.startTime !== "") {
      obj.startTime = message.startTime;
    }
    if (message.endTime !== "") {
      obj.endTime = message.endTime;
    }
    if (message.interval !== "") {
      obj.interval = message.interval;
    }
    if (message.costCounter !== 0) {
      obj.costCounter = message.costCounter;
    }
    if (message.valueCounter !== 0) {
      obj.valueCounter = message.valueCounter;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PeriodicCostRecord>, I>>(base?: I): PeriodicCostRecord {
    return PeriodicCostRecord.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PeriodicCostRecord>, I>>(object: I): PeriodicCostRecord {
    const message = createBasePeriodicCostRecord();
    message.id = object.id ?? 0;
    message.billingUnitId = object.billingUnitId ?? 0;
    message.billingUnit = (object.billingUnit !== undefined && object.billingUnit !== null)
      ? BillingUnit.fromPartial(object.billingUnit)
      : undefined;
    message.startTime = object.startTime ?? "";
    message.endTime = object.endTime ?? "";
    message.interval = object.interval ?? "";
    message.costCounter = object.costCounter ?? 0;
    message.valueCounter = object.valueCounter ?? 0;
    return message;
  },
};

function createBaseBillingUnit(): BillingUnit {
  return {
    id: 0,
    resourceId: "",
    description: undefined,
    kind: "",
    name: "",
    namespace: "",
    type: "",
    subresourceName: "",
    subresourceValue: undefined,
    attributes: {},
    pricePerUnit: 0,
    creationTimestamp: "",
    deletionTimestamp: undefined,
  };
}

export const BillingUnit = {
  encode(message: BillingUnit, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== 0) {
      writer.uint32(8).int64(message.id);
    }
    if (message.resourceId !== "") {
      writer.uint32(18).string(message.resourceId);
    }
    if (message.description !== undefined) {
      writer.uint32(26).string(message.description);
    }
    if (message.kind !== "") {
      writer.uint32(34).string(message.kind);
    }
    if (message.name !== "") {
      writer.uint32(42).string(message.name);
    }
    if (message.namespace !== "") {
      writer.uint32(50).string(message.namespace);
    }
    if (message.type !== "") {
      writer.uint32(58).string(message.type);
    }
    if (message.subresourceName !== "") {
      writer.uint32(66).string(message.subresourceName);
    }
    if (message.subresourceValue !== undefined) {
      writer.uint32(74).string(message.subresourceValue);
    }
    Object.entries(message.attributes).forEach(([key, value]) => {
      BillingUnit_AttributesEntry.encode({ key: key as any, value }, writer.uint32(82).fork()).ldelim();
    });
    if (message.pricePerUnit !== 0) {
      writer.uint32(89).double(message.pricePerUnit);
    }
    if (message.creationTimestamp !== "") {
      writer.uint32(98).string(message.creationTimestamp);
    }
    if (message.deletionTimestamp !== undefined) {
      writer.uint32(106).string(message.deletionTimestamp);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): BillingUnit {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBillingUnit();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.resourceId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.kind = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.name = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.namespace = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.type = reader.string();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.subresourceName = reader.string();
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.subresourceValue = reader.string();
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          const entry10 = BillingUnit_AttributesEntry.decode(reader, reader.uint32());
          if (entry10.value !== undefined) {
            message.attributes[entry10.key] = entry10.value;
          }
          continue;
        case 11:
          if (tag !== 89) {
            break;
          }

          message.pricePerUnit = reader.double();
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.creationTimestamp = reader.string();
          continue;
        case 13:
          if (tag !== 106) {
            break;
          }

          message.deletionTimestamp = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BillingUnit {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      resourceId: isSet(object.resourceId) ? globalThis.String(object.resourceId) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      kind: isSet(object.kind) ? globalThis.String(object.kind) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      namespace: isSet(object.namespace) ? globalThis.String(object.namespace) : "",
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      subresourceName: isSet(object.subresourceName) ? globalThis.String(object.subresourceName) : "",
      subresourceValue: isSet(object.subresourceValue) ? globalThis.String(object.subresourceValue) : undefined,
      attributes: isObject(object.attributes)
        ? Object.entries(object.attributes).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
      pricePerUnit: isSet(object.pricePerUnit) ? globalThis.Number(object.pricePerUnit) : 0,
      creationTimestamp: isSet(object.creationTimestamp) ? globalThis.String(object.creationTimestamp) : "",
      deletionTimestamp: isSet(object.deletionTimestamp) ? globalThis.String(object.deletionTimestamp) : undefined,
    };
  },

  toJSON(message: BillingUnit): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.resourceId !== "") {
      obj.resourceId = message.resourceId;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.kind !== "") {
      obj.kind = message.kind;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.namespace !== "") {
      obj.namespace = message.namespace;
    }
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.subresourceName !== "") {
      obj.subresourceName = message.subresourceName;
    }
    if (message.subresourceValue !== undefined) {
      obj.subresourceValue = message.subresourceValue;
    }
    if (message.attributes) {
      const entries = Object.entries(message.attributes);
      if (entries.length > 0) {
        obj.attributes = {};
        entries.forEach(([k, v]) => {
          obj.attributes[k] = v;
        });
      }
    }
    if (message.pricePerUnit !== 0) {
      obj.pricePerUnit = message.pricePerUnit;
    }
    if (message.creationTimestamp !== "") {
      obj.creationTimestamp = message.creationTimestamp;
    }
    if (message.deletionTimestamp !== undefined) {
      obj.deletionTimestamp = message.deletionTimestamp;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BillingUnit>, I>>(base?: I): BillingUnit {
    return BillingUnit.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BillingUnit>, I>>(object: I): BillingUnit {
    const message = createBaseBillingUnit();
    message.id = object.id ?? 0;
    message.resourceId = object.resourceId ?? "";
    message.description = object.description ?? undefined;
    message.kind = object.kind ?? "";
    message.name = object.name ?? "";
    message.namespace = object.namespace ?? "";
    message.type = object.type ?? "";
    message.subresourceName = object.subresourceName ?? "";
    message.subresourceValue = object.subresourceValue ?? undefined;
    message.attributes = Object.entries(object.attributes ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    message.pricePerUnit = object.pricePerUnit ?? 0;
    message.creationTimestamp = object.creationTimestamp ?? "";
    message.deletionTimestamp = object.deletionTimestamp ?? undefined;
    return message;
  },
};

function createBaseBillingUnit_AttributesEntry(): BillingUnit_AttributesEntry {
  return { key: "", value: 0 };
}

export const BillingUnit_AttributesEntry = {
  encode(message: BillingUnit_AttributesEntry, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): BillingUnit_AttributesEntry {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBillingUnit_AttributesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        case 2:
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BillingUnit_AttributesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: BillingUnit_AttributesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BillingUnit_AttributesEntry>, I>>(base?: I): BillingUnit_AttributesEntry {
    return BillingUnit_AttributesEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BillingUnit_AttributesEntry>, I>>(object: I): BillingUnit_AttributesEntry {
    const message = createBaseBillingUnit_AttributesEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBaseMeta(): Meta {
  return { page: 0, pageSize: 0, total: 0, totalPages: 0, hasNext: false, hasPrevious: false };
}

export const Meta = {
  encode(message: Meta, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.page !== 0) {
      writer.uint32(8).int32(message.page);
    }
    if (message.pageSize !== 0) {
      writer.uint32(16).int32(message.pageSize);
    }
    if (message.total !== 0) {
      writer.uint32(24).int32(message.total);
    }
    if (message.totalPages !== 0) {
      writer.uint32(32).int32(message.totalPages);
    }
    if (message.hasNext !== false) {
      writer.uint32(40).bool(message.hasNext);
    }
    if (message.hasPrevious !== false) {
      writer.uint32(48).bool(message.hasPrevious);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Meta {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMeta();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.page = reader.int32();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.pageSize = reader.int32();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.total = reader.int32();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.totalPages = reader.int32();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.hasNext = reader.bool();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.hasPrevious = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Meta {
    return {
      page: isSet(object.page) ? globalThis.Number(object.page) : 0,
      pageSize: isSet(object.pageSize) ? globalThis.Number(object.pageSize) : 0,
      total: isSet(object.total) ? globalThis.Number(object.total) : 0,
      totalPages: isSet(object.totalPages) ? globalThis.Number(object.totalPages) : 0,
      hasNext: isSet(object.hasNext) ? globalThis.Boolean(object.hasNext) : false,
      hasPrevious: isSet(object.hasPrevious) ? globalThis.Boolean(object.hasPrevious) : false,
    };
  },

  toJSON(message: Meta): unknown {
    const obj: any = {};
    if (message.page !== 0) {
      obj.page = Math.round(message.page);
    }
    if (message.pageSize !== 0) {
      obj.pageSize = Math.round(message.pageSize);
    }
    if (message.total !== 0) {
      obj.total = Math.round(message.total);
    }
    if (message.totalPages !== 0) {
      obj.totalPages = Math.round(message.totalPages);
    }
    if (message.hasNext !== false) {
      obj.hasNext = message.hasNext;
    }
    if (message.hasPrevious !== false) {
      obj.hasPrevious = message.hasPrevious;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Meta>, I>>(base?: I): Meta {
    return Meta.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Meta>, I>>(object: I): Meta {
    const message = createBaseMeta();
    message.page = object.page ?? 0;
    message.pageSize = object.pageSize ?? 0;
    message.total = object.total ?? 0;
    message.totalPages = object.totalPages ?? 0;
    message.hasNext = object.hasNext ?? false;
    message.hasPrevious = object.hasPrevious ?? false;
    return message;
  },
};

function createBaseResourceNameListRequest(): ResourceNameListRequest {
  return { startTime: "", endTime: "", namespace: "", kind: "", type: "", subresource: "", nameRegex: "" };
}

export const ResourceNameListRequest = {
  encode(message: ResourceNameListRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.startTime !== "") {
      writer.uint32(10).string(message.startTime);
    }
    if (message.endTime !== "") {
      writer.uint32(18).string(message.endTime);
    }
    if (message.namespace !== "") {
      writer.uint32(26).string(message.namespace);
    }
    if (message.kind !== "") {
      writer.uint32(34).string(message.kind);
    }
    if (message.type !== "") {
      writer.uint32(42).string(message.type);
    }
    if (message.subresource !== "") {
      writer.uint32(50).string(message.subresource);
    }
    if (message.nameRegex !== "") {
      writer.uint32(58).string(message.nameRegex);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ResourceNameListRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResourceNameListRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.startTime = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.endTime = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.namespace = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.kind = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.type = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.subresource = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.nameRegex = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ResourceNameListRequest {
    return {
      startTime: isSet(object.startTime) ? globalThis.String(object.startTime) : "",
      endTime: isSet(object.endTime) ? globalThis.String(object.endTime) : "",
      namespace: isSet(object.namespace) ? globalThis.String(object.namespace) : "",
      kind: isSet(object.kind) ? globalThis.String(object.kind) : "",
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      subresource: isSet(object.subresource) ? globalThis.String(object.subresource) : "",
      nameRegex: isSet(object.nameRegex) ? globalThis.String(object.nameRegex) : "",
    };
  },

  toJSON(message: ResourceNameListRequest): unknown {
    const obj: any = {};
    if (message.startTime !== "") {
      obj.startTime = message.startTime;
    }
    if (message.endTime !== "") {
      obj.endTime = message.endTime;
    }
    if (message.namespace !== "") {
      obj.namespace = message.namespace;
    }
    if (message.kind !== "") {
      obj.kind = message.kind;
    }
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.subresource !== "") {
      obj.subresource = message.subresource;
    }
    if (message.nameRegex !== "") {
      obj.nameRegex = message.nameRegex;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ResourceNameListRequest>, I>>(base?: I): ResourceNameListRequest {
    return ResourceNameListRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ResourceNameListRequest>, I>>(object: I): ResourceNameListRequest {
    const message = createBaseResourceNameListRequest();
    message.startTime = object.startTime ?? "";
    message.endTime = object.endTime ?? "";
    message.namespace = object.namespace ?? "";
    message.kind = object.kind ?? "";
    message.type = object.type ?? "";
    message.subresource = object.subresource ?? "";
    message.nameRegex = object.nameRegex ?? "";
    return message;
  },
};

function createBaseResourceNameListReply(): ResourceNameListReply {
  return { list: [] };
}

export const ResourceNameListReply = {
  encode(message: ResourceNameListReply, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.list) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ResourceNameListReply {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResourceNameListReply();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.list.push(reader.string());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ResourceNameListReply {
    return { list: globalThis.Array.isArray(object?.list) ? object.list.map((e: any) => globalThis.String(e)) : [] };
  },

  toJSON(message: ResourceNameListReply): unknown {
    const obj: any = {};
    if (message.list?.length) {
      obj.list = message.list;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ResourceNameListReply>, I>>(base?: I): ResourceNameListReply {
    return ResourceNameListReply.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ResourceNameListReply>, I>>(object: I): ResourceNameListReply {
    const message = createBaseResourceNameListReply();
    message.list = object.list?.map((e) => e) || [];
    return message;
  },
};

export type BillsystemServiceDefinition = typeof BillsystemServiceDefinition;
export const BillsystemServiceDefinition = {
  name: "BillsystemService",
  fullName: "bff.v1.BillsystemService",
  methods: {
    agreementList: {
      name: "AgreementList",
      requestType: AgreementListRequest,
      requestStream: false,
      responseType: AgreementListReply,
      responseStream: false,
      options: {
        _unknownFields: {
          578365826: [
            new Uint8Array([
              25,
              18,
              23,
              47,
              118,
              49,
              47,
              98,
              102,
              102,
              47,
              98,
              105,
              108,
              108,
              47,
              97,
              103,
              114,
              101,
              101,
              109,
              101,
              110,
              116,
              115,
            ]),
          ],
        },
      },
    },
    createAgreement: {
      name: "CreateAgreement",
      requestType: CreateAgreementRequest,
      requestStream: false,
      responseType: CreateAgreementReply,
      responseStream: false,
      options: {
        _unknownFields: {
          578365826: [
            new Uint8Array([
              28,
              34,
              23,
              47,
              118,
              49,
              47,
              98,
              102,
              102,
              47,
              98,
              105,
              108,
              108,
              47,
              97,
              103,
              114,
              101,
              101,
              109,
              101,
              110,
              116,
              115,
              58,
              1,
              42,
            ]),
          ],
        },
      },
    },
    editAgreementClient: {
      name: "EditAgreementClient",
      requestType: EditAgreementClientRequest,
      requestStream: false,
      responseType: EditAgreementClientReply,
      responseStream: false,
      options: {
        _unknownFields: {
          578365826: [
            new Uint8Array([
              35,
              26,
              30,
              47,
              118,
              49,
              47,
              98,
              102,
              102,
              47,
              98,
              105,
              108,
              108,
              47,
              97,
              103,
              114,
              101,
              101,
              109,
              101,
              110,
              116,
              115,
              47,
              99,
              108,
              105,
              101,
              110,
              116,
              58,
              1,
              42,
            ]),
          ],
        },
      },
    },
    editAgreementDetails: {
      name: "EditAgreementDetails",
      requestType: EditAgreementDetailsRequest,
      requestStream: false,
      responseType: EditAgreementDetailsReply,
      responseStream: false,
      options: {
        _unknownFields: {
          578365826: [
            new Uint8Array([
              36,
              26,
              31,
              47,
              118,
              49,
              47,
              98,
              102,
              102,
              47,
              98,
              105,
              108,
              108,
              47,
              97,
              103,
              114,
              101,
              101,
              109,
              101,
              110,
              116,
              115,
              47,
              100,
              101,
              116,
              97,
              105,
              108,
              115,
              58,
              1,
              42,
            ]),
          ],
        },
      },
    },
    agreementInfo: {
      name: "AgreementInfo",
      requestType: AgreementInfoRequest,
      requestStream: false,
      responseType: AgreementInfoReply,
      responseStream: false,
      options: {
        _unknownFields: {
          578365826: [
            new Uint8Array([
              40,
              18,
              38,
              47,
              118,
              49,
              47,
              98,
              102,
              102,
              47,
              98,
              105,
              108,
              108,
              47,
              97,
              103,
              114,
              101,
              101,
              109,
              101,
              110,
              116,
              115,
              47,
              123,
              97,
              103,
              114,
              101,
              101,
              109,
              101,
              110,
              116,
              95,
              105,
              100,
              125,
            ]),
          ],
        },
      },
    },
    deleteAgreement: {
      name: "DeleteAgreement",
      requestType: DeleteAgreementRequest,
      requestStream: false,
      responseType: DeleteAgreementReply,
      responseStream: false,
      options: {
        _unknownFields: {
          578365826: [
            new Uint8Array([
              40,
              42,
              38,
              47,
              118,
              49,
              47,
              98,
              102,
              102,
              47,
              98,
              105,
              108,
              108,
              47,
              97,
              103,
              114,
              101,
              101,
              109,
              101,
              110,
              116,
              115,
              47,
              123,
              97,
              103,
              114,
              101,
              101,
              109,
              101,
              110,
              116,
              95,
              105,
              100,
              125,
            ]),
          ],
        },
      },
    },
    paymentTracker: {
      name: "PaymentTracker",
      requestType: PaymentTrackerRequest,
      requestStream: false,
      responseType: PaymentTrackerReply,
      responseStream: false,
      options: {
        _unknownFields: {
          578365826: [
            new Uint8Array([
              31,
              18,
              29,
              47,
              118,
              49,
              47,
              98,
              102,
              102,
              47,
              98,
              105,
              108,
              108,
              47,
              112,
              97,
              121,
              109,
              101,
              110,
              116,
              115,
              47,
              116,
              114,
              97,
              99,
              107,
              101,
              114,
            ]),
          ],
        },
      },
    },
    paymentList: {
      name: "PaymentList",
      requestType: PaymentListRequest,
      requestStream: false,
      responseType: PaymentListReply,
      responseStream: false,
      options: {
        _unknownFields: {
          578365826: [
            new Uint8Array([
              23,
              18,
              21,
              47,
              118,
              49,
              47,
              98,
              102,
              102,
              47,
              98,
              105,
              108,
              108,
              47,
              112,
              97,
              121,
              109,
              101,
              110,
              116,
              115,
            ]),
          ],
        },
      },
    },
    createPayment: {
      name: "CreatePayment",
      requestType: CreatePaymentRequest,
      requestStream: false,
      responseType: CreatePaymentReply,
      responseStream: false,
      options: {
        _unknownFields: {
          578365826: [
            new Uint8Array([
              26,
              34,
              21,
              47,
              118,
              49,
              47,
              98,
              102,
              102,
              47,
              98,
              105,
              108,
              108,
              47,
              112,
              97,
              121,
              109,
              101,
              110,
              116,
              115,
              58,
              1,
              42,
            ]),
          ],
        },
      },
    },
    editPayment: {
      name: "EditPayment",
      requestType: EditPaymentRequest,
      requestStream: false,
      responseType: EditPaymentReply,
      responseStream: false,
      options: {
        _unknownFields: {
          578365826: [
            new Uint8Array([
              26,
              26,
              21,
              47,
              118,
              49,
              47,
              98,
              102,
              102,
              47,
              98,
              105,
              108,
              108,
              47,
              112,
              97,
              121,
              109,
              101,
              110,
              116,
              115,
              58,
              1,
              42,
            ]),
          ],
        },
      },
    },
    paymentInfo: {
      name: "PaymentInfo",
      requestType: PaymentInfoRequest,
      requestStream: false,
      responseType: PaymentInfoReply,
      responseStream: false,
      options: {
        _unknownFields: {
          578365826: [
            new Uint8Array([
              36,
              18,
              34,
              47,
              118,
              49,
              47,
              98,
              102,
              102,
              47,
              98,
              105,
              108,
              108,
              47,
              112,
              97,
              121,
              109,
              101,
              110,
              116,
              115,
              47,
              123,
              112,
              97,
              121,
              109,
              101,
              110,
              116,
              95,
              105,
              100,
              125,
            ]),
          ],
        },
      },
    },
    deletePayment: {
      name: "DeletePayment",
      requestType: DeletePaymentRequest,
      requestStream: false,
      responseType: DeletePaymentReply,
      responseStream: false,
      options: {
        _unknownFields: {
          578365826: [
            new Uint8Array([
              36,
              42,
              34,
              47,
              118,
              49,
              47,
              98,
              102,
              102,
              47,
              98,
              105,
              108,
              108,
              47,
              112,
              97,
              121,
              109,
              101,
              110,
              116,
              115,
              47,
              123,
              112,
              97,
              121,
              109,
              101,
              110,
              116,
              95,
              105,
              100,
              125,
            ]),
          ],
        },
      },
    },
    agreementCostList: {
      name: "AgreementCostList",
      requestType: AgreementCostListRequest,
      requestStream: false,
      responseType: AgreementCostListReply,
      responseStream: false,
      options: {
        _unknownFields: {
          578365826: [
            new Uint8Array([19, 18, 17, 47, 118, 49, 47, 98, 102, 102, 47, 98, 105, 108, 108, 47, 99, 111, 115, 116]),
          ],
        },
      },
    },
    createAgreementCost: {
      name: "CreateAgreementCost",
      requestType: CreateAgreementCostRequest,
      requestStream: false,
      responseType: CreateAgreementCostReply,
      responseStream: false,
      options: {
        _unknownFields: {
          578365826: [
            new Uint8Array([
              22,
              34,
              17,
              47,
              118,
              49,
              47,
              98,
              102,
              102,
              47,
              98,
              105,
              108,
              108,
              47,
              99,
              111,
              115,
              116,
              58,
              1,
              42,
            ]),
          ],
        },
      },
    },
    editAgreementCost: {
      name: "EditAgreementCost",
      requestType: EditAgreementCostRequest,
      requestStream: false,
      responseType: EditAgreementCostReply,
      responseStream: false,
      options: {
        _unknownFields: {
          578365826: [
            new Uint8Array([
              22,
              26,
              17,
              47,
              118,
              49,
              47,
              98,
              102,
              102,
              47,
              98,
              105,
              108,
              108,
              47,
              99,
              111,
              115,
              116,
              58,
              1,
              42,
            ]),
          ],
        },
      },
    },
    agreementCostInfo: {
      name: "AgreementCostInfo",
      requestType: AgreementCostInfoRequest,
      requestStream: false,
      responseType: AgreementCostInfoReply,
      responseStream: false,
      options: {
        _unknownFields: {
          578365826: [
            new Uint8Array([
              29,
              18,
              27,
              47,
              118,
              49,
              47,
              98,
              102,
              102,
              47,
              98,
              105,
              108,
              108,
              47,
              99,
              111,
              115,
              116,
              47,
              123,
              99,
              111,
              115,
              116,
              95,
              105,
              100,
              125,
            ]),
          ],
        },
      },
    },
    deleteAgreementCost: {
      name: "DeleteAgreementCost",
      requestType: DeleteAgreementCostRequest,
      requestStream: false,
      responseType: DeleteAgreementCostReply,
      responseStream: false,
      options: {
        _unknownFields: {
          578365826: [
            new Uint8Array([
              29,
              42,
              27,
              47,
              118,
              49,
              47,
              98,
              102,
              102,
              47,
              98,
              105,
              108,
              108,
              47,
              99,
              111,
              115,
              116,
              47,
              123,
              99,
              111,
              115,
              116,
              95,
              105,
              100,
              125,
            ]),
          ],
        },
      },
    },
    withdrawMonthlyBill: {
      name: "WithdrawMonthlyBill",
      requestType: WithdrawMonthlyBillRequest,
      requestStream: false,
      responseType: WithdrawMonthlyBillReply,
      responseStream: false,
      options: {
        _unknownFields: {
          578365826: [
            new Uint8Array([
              29,
              18,
              27,
              47,
              118,
              49,
              47,
              98,
              102,
              102,
              47,
              98,
              105,
              108,
              108,
              47,
              119,
              105,
              116,
              104,
              100,
              114,
              97,
              119,
              95,
              98,
              105,
              108,
              108,
              115,
            ]),
          ],
        },
      },
    },
    costSummary: {
      name: "CostSummary",
      requestType: CostSummaryRequest,
      requestStream: false,
      responseType: CostSummaryReply,
      responseStream: false,
      options: {
        _unknownFields: {
          578365826: [
            new Uint8Array([
              22,
              18,
              20,
              47,
              118,
              49,
              47,
              98,
              102,
              102,
              47,
              99,
              111,
              115,
              116,
              47,
              115,
              117,
              109,
              109,
              97,
              114,
              121,
            ]),
          ],
        },
      },
    },
    costSummaryV2: {
      name: "CostSummaryV2",
      requestType: CostSummaryV2Request,
      requestStream: false,
      responseType: CostSummaryV2Reply,
      responseStream: false,
      options: {
        _unknownFields: {
          578365826: [
            new Uint8Array([
              25,
              18,
              23,
              47,
              118,
              49,
              47,
              98,
              102,
              102,
              47,
              99,
              111,
              115,
              116,
              47,
              115,
              117,
              109,
              109,
              97,
              114,
              121,
              95,
              118,
              50,
            ]),
          ],
        },
      },
    },
    resourceNamespaceList: {
      name: "ResourceNamespaceList",
      requestType: ResourceNamespaceListRequest,
      requestStream: false,
      responseType: ResourceNamespaceListReply,
      responseStream: false,
      options: {
        _unknownFields: {
          578365826: [
            new Uint8Array([
              34,
              18,
              32,
              47,
              118,
              49,
              47,
              98,
              102,
              102,
              47,
              99,
              111,
              115,
              116,
              47,
              114,
              101,
              115,
              111,
              117,
              114,
              99,
              101,
              95,
              110,
              97,
              109,
              101,
              115,
              112,
              97,
              99,
              101,
              115,
            ]),
          ],
        },
      },
    },
    businessCostSummary: {
      name: "BusinessCostSummary",
      requestType: BusinessCostSummaryRequest,
      requestStream: false,
      responseType: BusinessCostSummaryReply,
      responseStream: false,
      options: {
        _unknownFields: {
          578365826: [
            new Uint8Array([
              31,
              18,
              29,
              47,
              118,
              49,
              47,
              98,
              102,
              102,
              47,
              99,
              111,
              115,
              116,
              47,
              98,
              117,
              115,
              105,
              110,
              101,
              115,
              115,
              95,
              115,
              117,
              109,
              109,
              97,
              114,
              121,
            ]),
          ],
        },
      },
    },
    periodicCostRecords: {
      name: "PeriodicCostRecords",
      requestType: PeriodicCostRecordsRequest,
      requestStream: false,
      responseType: PeriodicCostRecordsReply,
      responseStream: false,
      options: {
        _unknownFields: {
          578365826: [
            new Uint8Array([
              31,
              18,
              29,
              47,
              118,
              49,
              47,
              98,
              102,
              102,
              47,
              99,
              111,
              115,
              116,
              47,
              112,
              101,
              114,
              105,
              111,
              100,
              105,
              99,
              95,
              114,
              101,
              99,
              111,
              114,
              100,
              115,
            ]),
          ],
        },
      },
    },
    resourceNameList: {
      name: "ResourceNameList",
      requestType: ResourceNameListRequest,
      requestStream: false,
      responseType: ResourceNameListReply,
      responseStream: false,
      options: {
        _unknownFields: {
          578365826: [
            new Uint8Array([
              33,
              18,
              31,
              47,
              118,
              49,
              47,
              98,
              102,
              102,
              47,
              99,
              111,
              115,
              116,
              47,
              114,
              101,
              115,
              111,
              117,
              114,
              99,
              101,
              95,
              110,
              97,
              109,
              101,
              95,
              108,
              105,
              115,
              116,
            ]),
          ],
        },
      },
    },
  },
} as const;

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
